import "./style.css";
import mainProject from "./data/mainproject.json";
import legal from "./data/legal.json";
// rm -rf dist .parcel-cache && npm run build && cp -r public/__ dist/ 
import {
  signInWithPopup,
  signInWithRedirect,
  signOut,
  onAuthStateChanged
} from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { auth, provider, db } from "./firebase.js";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

function sampltonAlert(options = {}) {
  return Swal.fire({
    background: "#0b1121",
    color: "#fff",
    confirmButtonColor: "#333",
    cancelButtonColor: "#222",
    ...options
  });
}

onAuthStateChanged(auth, async (user) => {

  currentUser = user;

  
  isPro = false;

  if (user) {
    

    try {
      const licenseRef = doc(db, "licenses", user.uid);
      const licenseSnap = await getDoc(licenseRef);

      isPro =
        licenseSnap.exists() &&
        licenseSnap.data().samplton === true;

   

    } catch (err) {
      console.error("License check failed:", err);
    }

  } else {
   
  }

  authReady = true;

  await init();
});


if ('launchQueue' in window) {
  launchQueue.setConsumer(async (launchParams) => {
    if (!launchParams.files.length) return;

    const fileHandle = launchParams.files[0];
    const file = await fileHandle.getFile();
    const text = await file.text();

    try {
      pendingFileData = JSON.parse(text);
    } catch (e) {
      await sampltonAlert({
        title: "Invalid file",
        text: "This is not a valid .samplton file.",
        icon: "error"
      });
    }
  });
}

async function isTrackCached(url) {
  const data = await loadFromDB(url);
  return !!data;
}

async function resetAppKeepAudio() {
  try {
    // 🔴 STOP AUDIO
    if (source) {
      try { source.stop(); } catch(e) {}
      source = null;
    }

    if (schedulerTimer) {
      clearTimeout(schedulerTimer);
      schedulerTimer = null;
    }

    // 🔥 1. IndexedDB → len PROJECTS store
    const db = await openDB();
    const tx = db.transaction("projects", "readwrite");
    await tx.objectStore("projects").clear();

    // 🔥 2. localStorage
    localStorage.clear();

    // 🔥 3. Service Worker cache (PWA)
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map(k => caches.delete(k)));
    }

    // 🔥 4. RESET RAM (dôležité)
    bufferCache.clear();

    songs = [];
    currentSongIndex = 0;
    selectedSongIndex = 0;
    selectedTrackIndex = 0;

    // 🔥 5. UI
    document.body.innerHTML = `
      <div style="color:white;padding:30px;text-align:center;">
        <h2>Done</h2>
        <p></p>
      </div>
    `;

    setTimeout(() => {
      location.reload();
    }, 800);

  } catch (err) {
    console.error("Reset failed:", err);
    await sampltonAlert({
      title: "Reset failed",
      icon: "error"
    });
  }
}

// GLOBALS

let trackSubtitleEl = null;

const FREE_STORAGE_LIMIT = 100 * 1024 * 1024; // 100 MB
const MAX_FREE_FILE_SIZE = 30 * 1024 * 1024; // 30 MB

let viewMode = "menu";
let sampleLibraryMode = false;
let sampleLibraryTargetTrackIndex = null;

let samplePreviewSource = null;
let samplePreviewBuffer = null;
let samplePreviewStartedAt = 0;
let samplePreviewOffset = 0;
let samplePreviewPaused = false;
let samplePreviewPad = null;
let songEditMode = false;
let draggedSongIndex = null;
let updateQuantPadFn = null;

let trackEditMode = false;
let draggedTrackIndex = null;

let trackSettingsMode = false;
let trackSettingsIndex = null;

let saveTimeout;
const STRIPE_BUY_URL = "https://buy.stripe.com/fZu8wQ8LPewK52K99PdfG01";
let currentUser = null;
let isPro = false;
let authReady = false;

function getLocalProjectKey() {
  if (currentUser?.uid) {
    return `main_${currentUser.uid}`;
  }

  return "main_guest";
}

function getUsedStorageBytes() {
  return songs
    .flatMap(song => song.tracks || [])
    .filter(track => isR2Audio(track.mp3))
    .reduce((sum, track) => sum + Number(track.fileSize || 0), 0);
}

// =======================
// LOAD TRACKS
// =======================

async function deleteFromDB(key) {
  const db = await openDB();
  const tx = db.transaction("files", "readwrite");

  return new Promise((resolve, reject) => {
    const req = tx.objectStore("files").delete(key);
    req.onsuccess = () => resolve();
    req.onerror = () => reject(req.error);
  });
}

async function deleteR2Audio(audioRef) {
  if (!isR2Audio(audioRef)) {
    return true;
  }

  if (!currentUser) {
    console.warn("Cannot delete R2 audio: no user");
    return false;
  }

  const fileName = getR2FileName(audioRef);
  const token = await currentUser.getIdToken();

  const res = await fetch(
    `${R2_API}/audio/${encodeURIComponent(fileName)}`,
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  const data = await res.json();

  if (!res.ok || !data.ok) {
    console.error("R2 delete failed:", data);
    return false;
  }

  console.log("🗑️ R2 deleted:", fileName);

  await deleteFromDB(audioRef);
bufferCache.delete(audioRef);


  return true;
}
async function detectAudioStart(file) {
  try {
    const arrayBuffer = await file.arrayBuffer();

    const ctx =
      new (window.AudioContext || window.webkitAudioContext)();

    const buffer = await ctx.decodeAudioData(
      arrayBuffer.slice(0)
    );

    const sampleRate = buffer.sampleRate;

    // kontrolujeme všetky kanály
    const channels = [];

    for (let c = 0; c < buffer.numberOfChannels; c++) {
      channels.push(buffer.getChannelData(c));
    }

    // -45 dB približne
    const threshold = 0.0056;

    // zvuk musí zostať nad hranicou aspoň cca 10 ms
    const requiredSamples =
      Math.floor(sampleRate * 0.01);

    let consecutive = 0;
    let startSample = 0;

    for (let i = 0; i < buffer.length; i++) {

      let amplitude = 0;

      for (const channel of channels) {
        amplitude = Math.max(
          amplitude,
          Math.abs(channel[i])
        );
      }

      if (amplitude > threshold) {
        consecutive++;

        if (consecutive >= requiredSamples) {
          startSample =
            i - requiredSamples + 1;
          break;
        }

      } else {
        consecutive = 0;
      }
    }

    await ctx.close();

    const startSeconds =
      startSample / sampleRate;

    return Math.max(
      0,
      Number(startSeconds.toFixed(3))
    );

  } catch (err) {
    console.warn(
      "Audio start detection failed:",
      err
    );

    return 0;
  }
}

async function analyzeAudio(file) {
  const result = {
    bpm: null,
    startAt: 0
  };

  let ctx = null;

  try {
    const arrayBuffer = await file.arrayBuffer();

    ctx = new (
      window.AudioContext ||
      window.webkitAudioContext
    )();

    const buffer = await ctx.decodeAudioData(
      arrayBuffer.slice(0)
    );

    const sampleRate = buffer.sampleRate;
    const length = buffer.length;

    // ==========================================
    // 1. DETEKCIA ZAČIATKU ZVUKU
    // ==========================================

    const channels = [];

    for (let c = 0; c < buffer.numberOfChannels; c++) {
      channels.push(buffer.getChannelData(c));
    }

    // cca -45 dB
    const startThreshold = 0.0056;

    // zvuk musí byť prítomný aspoň 10 ms,
    // aby jeden náhodný peak neurčil začiatok
    const requiredSamples =
      Math.floor(sampleRate * 0.01);

    let consecutive = 0;
    let startSample = 0;
    let foundStart = false;

    for (let i = 0; i < length; i++) {
      let amplitude = 0;

      for (const channel of channels) {
        amplitude = Math.max(
          amplitude,
          Math.abs(channel[i])
        );
      }

      if (amplitude >= startThreshold) {
        consecutive++;

        if (consecutive >= requiredSamples) {
          startSample =
            i - requiredSamples + 1;

          foundStart = true;
          break;
        }
      } else {
        consecutive = 0;
      }
    }

    if (!foundStart) {
      startSample = 0;
    }

    result.startAt = Number(
      (startSample / sampleRate).toFixed(3)
    );

    // ==========================================
    // 2. BPM DETECTION
    // ==========================================

    // BPM analyzujeme od reálneho začiatku zvuku
    // maximálne 90 sekúnd
    const analysisEnd = Math.min(
      length,
      startSample + sampleRate * 90
    );

    // mix kanálov pre analýzu
    const mono = new Float32Array(
      analysisEnd - startSample
    );

    for (
      let i = startSample;
      i < analysisEnd;
      i++
    ) {
      let sum = 0;

      for (const channel of channels) {
        sum += channel[i];
      }

      mono[i - startSample] =
        sum / channels.length;
    }

    // ==========================================
    // ENERGY WINDOWS
    // ==========================================

    // analyzujeme bloky cca 20 ms
    const windowSize =
      Math.max(1, Math.floor(sampleRate * 0.02));

    const energies = [];

    for (
      let i = 0;
      i < mono.length;
      i += windowSize
    ) {
      const end =
        Math.min(i + windowSize, mono.length);

      let energy = 0;

      for (let j = i; j < end; j++) {
        const sample = mono[j];
        energy += sample * sample;
      }

      energies.push(
        Math.sqrt(
          energy / Math.max(1, end - i)
        )
      );
    }

    // ==========================================
    // ONSET / TRANSIENT DETECTION
    // ==========================================

    const changes = [];

    for (let i = 1; i < energies.length; i++) {
      changes.push(
        Math.max(
          0,
          energies[i] - energies[i - 1]
        )
      );
    }

    if (changes.length < 10) {
      return result;
    }

    // adaptívny threshold
    const sortedChanges =
      [...changes].sort((a, b) => a - b);

    const percentileIndex =
      Math.floor(sortedChanges.length * 0.75);

    const threshold =
      sortedChanges[
        Math.min(
          percentileIndex,
          sortedChanges.length - 1
        )
      ] * 1.5;

    const onsetTimes = [];

    // minimálne cca 180 ms medzi onsetmi
    const minOnsetGap = 0.18;

    let lastOnsetTime = -Infinity;

    for (let i = 1; i < changes.length - 1; i++) {
      const change = changes[i];

      // lokálne maximum
      if (
        change >= threshold &&
        change >= changes[i - 1] &&
        change >= changes[i + 1]
      ) {
        const time =
          (i * windowSize) / sampleRate;

        if (
          time - lastOnsetTime >= minOnsetGap
        ) {
          onsetTimes.push(time);
          lastOnsetTime = time;
        }
      }
    }

    // ==========================================
    // BPM Z ROZDIELOV MEDZI ONSETMI
    // ==========================================

    if (onsetTimes.length >= 4) {
      const bpmScores = new Map();

      for (let i = 0; i < onsetTimes.length; i++) {

        // porovnaj s niekoľkými ďalšími onsetmi
        for (
          let j = i + 1;
          j < Math.min(i + 9, onsetTimes.length);
          j++
        ) {
          const seconds =
            onsetTimes[j] - onsetTimes[i];

          if (seconds <= 0) continue;

          let bpm = 60 / seconds;

          // normalizácia half/double-time
          while (bpm < 70) bpm *= 2;
          while (bpm > 180) bpm /= 2;

          const rounded = Math.round(bpm);

          // mierne tolerujeme susedné hodnoty
          for (let offset = -1; offset <= 1; offset++) {
            const candidate =
              rounded + offset;

            const distance =
              Math.abs(candidate - bpm);

            const weight =
              1 / (1 + distance);

            bpmScores.set(
              candidate,
              (bpmScores.get(candidate) || 0) +
              weight
            );
          }
        }
      }

      let bestBpm = null;
      let bestScore = -Infinity;

      for (const [bpm, score] of bpmScores) {
        if (score > bestScore) {
          bestScore = score;
          bestBpm = bpm;
        }
      }

      if (
        bestBpm &&
        bestBpm >= 70 &&
        bestBpm <= 180
      ) {
        result.bpm = bestBpm;
      }
    }

    console.log("🎵 Audio analysis:", {
      bpm: result.bpm,
      startAt: result.startAt
    });

    return result;

  } catch (err) {
    console.warn(
      "Audio analysis failed:",
      err
    );

    return result;

  } finally {
    if (ctx) {
      try {
        await ctx.close();
      } catch (e) {}
    }
  }
}

async function uploadTrackToR2(track, file) {
  if (!currentUser) {
    await sampltonAlert({
      title: "Sign in required",
      text: "To upload audio files, please sign in with Google from the menu.",
      icon: "info"
    });
    return false;
  }

  if (!isPro && file.size > MAX_FREE_FILE_SIZE) {
    await sampltonAlert({
      title: "File too large",
      text: "Free version allows files up to 30 MB.",
      icon: "warning"
    });
    return false;
  }

  if (!isPro) {
    const used = getUsedStorageBytes();

    const oldSize = isR2Audio(track.mp3)
      ? Number(track.fileSize || 0)
      : 0;

    const newTotal = used - oldSize + file.size;

    if (newTotal > FREE_STORAGE_LIMIT) {
      const usedMB = (used / 1024 / 1024).toFixed(1);
      const fileMB = (file.size / 1024 / 1024).toFixed(1);

      await sampltonAlert({
        title: "Storage limit reached",
        html: `
          Free storage limit is <b>100 MB</b>.<br><br>
          Used: <b>${usedMB} MB</b><br>
          This file: <b>${fileMB} MB</b><br><br>
          Upgrade to PRO for more storage.
        `,
        icon: "warning"
      });

      return false;
    }
  }

// =========================
  // AUDIO ANALYSIS
  // BPM + START
  // =========================

  try {
    const analysis = await analyzeAudio(file);

    if (analysis.bpm) {
      track.bpm = analysis.bpm;
    }

    if (
      Number.isFinite(analysis.startAt) &&
      analysis.startAt >= 0
    ) {
      track.start_at = analysis.startAt;
    }

    console.log(
      "🎵 Detected:",
      "BPM =", analysis.bpm,
      "START =", analysis.startAt  
    );

  } catch (err) {
    console.warn(
      "Audio analysis skipped:",
      err
    );
  }

  const oldAudioRef = track.mp3;
  const token = await currentUser.getIdToken();

  const formData = new FormData();
formData.append("file", file);

if (isR2Audio(track.mp3)) {
  formData.append(
    "oldFile",
    getR2FileName(track.mp3)
  );
}
  const res = await fetch(
    `${R2_API}/upload`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: formData
    }
  );

  const data = await res.json();

  if (!res.ok || !data.ok) {
    console.error("R2 upload failed:", data);
    await sampltonAlert({
      title: "Upload failed",
      text: data.error || `Error ${res.status}`,
      icon: "error"
    });
    return false;
  }

  // napr. r2:UUID.mp3
  const audioRef = `r2:${data.file}`;

  // =========================
  // LOCAL AUDIO CACHE
  // =========================
  const buffer = await file.arrayBuffer();

  await saveToDB(
    audioRef,
    buffer.slice(0)
  );

  // track teraz ukazuje na R2
  track.mp3 = audioRef;

  // Ak nemá meno, použi názov súboru
  if (
    !String(track.name || "").trim() ||
    track.name === "New Loop"
  ) {
    const fileNameWithoutExt =
      file.name.replace(/\.[^/.]+$/, "");
  
    track.name =
      fileNameWithoutExt.substring(0, 8);
  }
  
  // prípadne si necháme info
  track.fileName = file.name;
  track.fileSize = file.size;

  await saveProject();

  // RAM cache pripravíme tiež
  await prepareSong([track]);

  if (
    isR2Audio(oldAudioRef) &&
    oldAudioRef !== track.mp3
  ) {
    await deleteR2Audio(oldAudioRef);
  }

  console.log("✅ Track uploaded:", {
    mp3: track.mp3,
    fileName: file.name
  });

  return true;
}


async function loadTracks() {
  // 1. uložený projekt
  const project = await loadProject();

  if (project?.songs) {
    songs = project.songs;
    return songs.flatMap(s => s.tracks);
  }

  // 2. nič uložené → načítaj Demo Project
  songs = structuredClone(mainProject.songs);

  await saveProject();

  return songs.flatMap(s => s.tracks);
}
// =======================
// TABLE GOOGLE
// =======================



function renderSongsTable() {
  if (sheetEditorEl) {
    sheetEditorEl.style.display = "block";
    return;
  }

  const wrapper = document.createElement("div");
  wrapper.className = "sheet-editor";
  sheetEditorEl = wrapper;

  // ❌ CLOSE
  const closeBtn = document.createElement("div");
  closeBtn.textContent = "✕";
  closeBtn.className = "pad-mini sheet-close";
  closeBtn.onclick = () => {
    wrapper.remove();
    sheetEditorEl = null;
    renderSong();
  };
  wrapper.appendChild(closeBtn);

  // ➕ ADD SONG
  const addBtn = document.createElement("div");
  addBtn.textContent = "+";
  addBtn.className = "pad-mini sheet-add";

  addBtn.onclick = async () => {

    // FREE používateľ môže mať iba 1 song
    if (!isPro && songs.length >= 1) {
      wrapper.remove();
      sheetEditorEl = null;
  
      viewMode = "menu";
      renderSong();
      return;
    }
  
    const newSong = {
      title: "New Song",
      tracks: []
    };
  
    songs.push(newSong);
  
    await saveProject();
  
    console.log("➕ Song added:", newSong.title);
  
    wrapper.remove();
    sheetEditorEl = null;
  
    renderSongsTable();
  };

  wrapper.appendChild(addBtn);

  const table = document.createElement("table");
  table.className = "sheet-table";

  // 🔷 HEADER
  const thead = document.createElement("thead");
  const headRow = document.createElement("tr");

  const thMove = document.createElement("th");
  thMove.textContent = "↕";
  headRow.appendChild(thMove);

  const thDel = document.createElement("th");
  thDel.textContent = "✕";
  headRow.appendChild(thDel);

  const thTitle = document.createElement("th");
  thTitle.textContent = "title";
  headRow.appendChild(thTitle);

  thead.appendChild(headRow);
  table.appendChild(thead);

  const tbody = document.createElement("tbody");

  songs.forEach((song, index) => {
    const tr = document.createElement("tr");

   
    
    tr.style.cursor = "pointer";

    // 🔼🔽 MOVE
    const tdMove = document.createElement("td");

    const up = document.createElement("button");
    up.textContent = "⬆";

    const down = document.createElement("button");
    down.textContent = "⬇";

    up.onclick = () => {
      if (index === 0) return;

      [songs[index - 1], songs[index]] =
        [songs[index], songs[index - 1]];

      saveProject();
      wrapper.remove();
      sheetEditorEl = null;
      renderSongsTable();
        };

    down.onclick = () => {
      if (index === songs.length - 1) return;

      [songs[index + 1], songs[index]] =
        [songs[index], songs[index + 1]];

      saveProject();
      wrapper.remove();
      sheetEditorEl = null;
      renderSongsTable();
        };

    tdMove.appendChild(up);
    tdMove.appendChild(down);
    tr.appendChild(tdMove);

    // ❌ DELETE
    const tdDel = document.createElement("td");
    tdDel.textContent = "✕";

    tdDel.onclick = async () => {
      const songToDelete = songs[index];
      if (!songToDelete) return;
    
      const tracks = songToDelete.tracks || [];
    
     
    
      // 2. Až keď sú R2 súbory preč, odstráň skladbu
      songs.splice(index, 1);
    
      // 3. Ulož nový projekt
      await saveProject();
    
      console.log(
        "🗑️ Song deleted:",
        songToDelete.title,
        `(${tracks.length} tracks)`
      );
    
      // 4. Prekresli Songs Table
      wrapper.remove();
      renderSongsTable();
    
     
    };
    tr.appendChild(tdDel);

    // ✏️ TITLE
    const tdTitle = document.createElement("td");
    tdTitle.contentEditable = true;
    tdTitle.textContent = song.title;

    tdTitle.oninput = () => {
      let val = tdTitle.textContent.trim();
    
      if (isOnlyNumber(val)) {
        val = "New Song";
        tdTitle.textContent = val;
      }
    
      song.title = val;
      saveProject();
    };

    tr.appendChild(tdTitle);

    tbody.appendChild(tr);
  });

  table.appendChild(tbody);
  wrapper.appendChild(table);
  document.body.appendChild(wrapper);
}

let sheetEditorEl = null;



function renderEditableTable(tracks) {
  if (sheetEditorEl) {
    sheetEditorEl.style.display = "block";
    return;
  }

  const wrapper = document.createElement("div");
  wrapper.className = "sheet-editor";
  sheetEditorEl = wrapper;

  let updatePosition = null;

  // ❌ CLOSE
  const closeBtn = document.createElement("div");
  closeBtn.textContent = "✕";
  closeBtn.className = "pad-mini sheet-close";
  if (window.visualViewport) {
    const updatePosition = () => {
      const viewportHeight = visualViewport.height;
      const windowHeight = window.innerHeight;
  
      const keyboardHeight = windowHeight - viewportHeight;
  
      if (keyboardHeight > 100) {
        closeBtn.style.bottom = (keyboardHeight + 15) + "px";
      } else {
        closeBtn.style.bottom = "15px";
      }
    };
  
    visualViewport.addEventListener("resize", updatePosition);
    visualViewport.addEventListener("scroll", updatePosition);
  }
  closeBtn.onclick = () => {
    visualViewport.removeEventListener("resize", updatePosition);
  visualViewport.removeEventListener("scroll", updatePosition);

    wrapper.remove();
    sheetEditorEl = null;
  renderSong(); 
  };
    wrapper.appendChild(closeBtn);

  // ➕ ADD ROW
  const addBtn = document.createElement("div");
  addBtn.textContent = "+";
  addBtn.className = "pad-mini sheet-add";

  addBtn.onclick = async () => {
    const currentSongTitle = songs[currentSongIndex]?.title || "New";

    const lastTrack = tracks[tracks.length - 1];
  
    const newTrack = {
      song: currentSongTitle,
      name: "New Loop",
      notes: "",
      mp3: "",
      bpm: lastTrack ? lastTrack.bpm : 120,
      signature: 4,
      bars: 4,
      start_at: 0.01,
      fadeintime: 0.5,
      repeat: 1
    };
  
    tracks.push(newTrack);
  
    await saveProject();

    const project = await loadProject();
if (project?.songs) {
  songs = project.songs;
}
  
  
    wrapper.remove();
    sheetEditorEl = null;
  
    renderSong();
  
    const song = songs[currentSongIndex];
    if (song) {
      renderEditableTable(song.tracks);
    }
  };  
  wrapper.appendChild(addBtn);

  const table = document.createElement("table");
  table.className = "sheet-table";

  // 🧠 fallback headers
  const headers = [
    "start_at",
    "bars",
    "name",
    "mp3",
    "bpm",
    "repeat",
    "signature",
    "autoplay",
    "notes",
    "fadeintime"
  ];  // 🔷 HEADER
  const thead = document.createElement("thead");
  const headRow = document.createElement("tr");

  const thDrag = document.createElement("th");
thDrag.textContent = "⋮"; // alebo nechaj prázdne ""
headRow.appendChild(thDrag);

  // normal columns
  headers.forEach(h => {
    const th = document.createElement("th");
    th.textContent = h;
    headRow.appendChild(th);
  });
  

  const thMove = document.createElement("th");
thMove.textContent = "↕";
headRow.appendChild(thMove);

  // delete column
  const thDel = document.createElement("th");
  thDel.textContent = "✕";
  headRow.appendChild(thDel);


  thead.appendChild(headRow);
  table.appendChild(thead);

  const tbody = document.createElement("tbody");

  let dragIndex = null;

  tracks.forEach((track, rowIndex) => {
    const tr = document.createElement("tr");

    const tdDrag = document.createElement("td");
tdDrag.className = "sheet-drag";

const dragIcon = document.createElement("div");
dragIcon.className = "drag-handle";
dragIcon.innerHTML = "⠿";

dragIcon.draggable = true;

dragIcon.addEventListener("dragstart", () => {
  dragIndex = rowIndex;
  tr.classList.add("dragging");
});

dragIcon.addEventListener("dragend", () => {
  tr.classList.remove("dragging");
});

tdDrag.appendChild(dragIcon);
tr.appendChild(tdDrag);


    // ✏️ DATA CELLS
    headers.forEach(h => {
      const td = document.createElement("td");

      if (h === "mp3") {
        const uploadBtn = document.createElement("button");
        uploadBtn.textContent = track.mp3
          ? "CHANGE"
          : "UPLOAD";
      
        const fileInfo = document.createElement("div");
        fileInfo.style.fontSize = "10px";
        fileInfo.style.marginTop = "4px";
      
        if (isR2Audio(track.mp3)) {
          fileInfo.textContent =
            track.fileName || getR2FileName(track.mp3);
        } else {
          fileInfo.textContent =
            track.mp3
              ? getFileName(track.mp3)
              : "";
        }
      
        uploadBtn.onclick = async () => {

          if (!currentUser) {
        
            await sampltonAlert({
              title: "Sign in required",
              text: "To upload audio files, please sign in with Google from the menu.",
              icon: "info"
            });
        
            return;
          }
        
          const input = document.createElement("input");
      
          input.type = "file";
          input.accept = "audio/*,.wav,.mp3,.flac,.ogg";
      
          input.onchange = async () => {
            const file = input.files?.[0];
            if (!file) return;
      
            uploadBtn.disabled = true;
            uploadBtn.textContent = "UPLOADING...";
      
            try {
              const ok = await uploadTrackToR2(
                track,
                file
              );
      
              if (ok) {
                fileInfo.textContent = file.name;
                uploadBtn.textContent = "CHANGE";
              
                updatePadUI(track);
              
                // ak track predtým nemal mp3, pad ešte nemusel existovať
                const song = songs[currentSongIndex];
              
                if (song) {
                  wrapper.remove();
                  sheetEditorEl = null;
              
                  renderSong();
              
                  setTimeout(() => {
                    renderEditableTable(
                      songs[currentSongIndex].tracks
                    );
                  }, 0);
                }
              } else {
                uploadBtn.textContent = "UPLOAD";
              }
      
            } catch (err) {
              console.error(err);
              uploadBtn.textContent = "ERROR";
      
            } finally {
              uploadBtn.disabled = false;
            }
          };
      
          input.click();
        };
      
        td.appendChild(uploadBtn);
        td.appendChild(fileInfo);
      
        tr.appendChild(td);
      
        return;
      }

      const numericFields = [
        "start_at",
        "bars",
        "bpm",
        "repeat",
        "signature",
        "fadeintime",
        "autoplay"
      ];
      
      if (numericFields.includes(h)) {
        const input = document.createElement("input");
        input.type = "number";
        input.inputMode = "decimal"; // 🔥 mobile keyboard
        input.step = "any"; 
        input.value = track[h] ?? "";
      
        input.addEventListener("input", async () => {
          const val = input.value;
        
          const num = toNumber(val);
          track[h] = num;
        
          if (h === "start_at") track.start_at = num || 0.01;
          if (h === "bpm") track.bpm = num;
          if (h === "bars") track.bars = num;
          if (h === "repeat") track.repeat = num || 1;
          if (h === "signature") track.signature = num || 4;
          if (h === "autoplay") track.autoplay = num;
        
          handleLiveUpdate(track);
          updatePadUI(track);
          scheduleSave(tracks);
        });
      
        td.appendChild(input);
      
      } else {
        td.contentEditable = true;
        td.textContent = track[h] ?? "";
      
        td.addEventListener("input", async () => {
          let val = td.textContent;
      
          if (h === "name" || h === "song") {
            val = String(val);
      
            if (isOnlyNumber(val)) {
              val = "Loop";
              td.textContent = val;
            }
          }
      
          if (h === "notes") {
            val = String(val);
          } else {
            val = val.trim();
          }
      
          track[h] = val;
      
          if (h === "mp3") {
            track.mp3 = fixUrl(val);
      
            if (track.mp3) {
              await cacheSongTracks([track]);
              await prepareSong([track]);
            }
          }
      
          handleLiveUpdate(track);
          updatePadUI(track);
          scheduleSave(tracks);
        });
      }

      tr.appendChild(td);
    });

    // 🔼🔽 MOVE CELL
const tdMove = document.createElement("td");
tdMove.className = "sheet-move";

const up = document.createElement("button");
up.textContent = "⬆";

const down = document.createElement("button");
down.textContent = "⬇";

up.onclick = () => {
  if (rowIndex === 0) return;

  const song = songs[currentSongIndex];

  [song.tracks[rowIndex - 1], song.tracks[rowIndex]] =
    [song.tracks[rowIndex], song.tracks[rowIndex - 1]];

    saveProject();

  renderSong(); // 🔥 len toto

  // 🔥 reopen table so správnymi dátami
  setTimeout(() => {
    renderEditableTable(songs[currentSongIndex].tracks);
  }, 0);
};

down.onclick = () => {
  const song = songs[currentSongIndex];

  if (rowIndex === song.tracks.length - 1) return;

  [song.tracks[rowIndex + 1], song.tracks[rowIndex]] =
    [song.tracks[rowIndex], song.tracks[rowIndex + 1]];

    saveProject();

  renderSong(); // 🔥 redraw UI

  // 🔥 reopen table s fresh dátami
  setTimeout(() => {
    renderEditableTable(songs[currentSongIndex].tracks);
  }, 0);
};

tdMove.appendChild(up);
tdMove.appendChild(down);
tr.appendChild(tdMove);

    // ❌ DELETE CELL
    const tdDel = document.createElement("td");
    tdDel.textContent = "✕";
    tdDel.className = "sheet-delete";

    tdDel.onclick = async () => {
      const trackToDelete = tracks[rowIndex];
      if (!trackToDelete) return;
    
      const audioRef = trackToDelete.mp3;
    
      // Najprv zmaž audio z R2
      if (isR2Audio(audioRef)) {
        const ok = await deleteR2Audio(audioRef);
    
        if (!ok) {
          alert("R2 audio sa nepodarilo vymazať.");
          return;
        }
      }
    
      // Potom odstráň track z projektu
      tracks.splice(rowIndex, 1);
    
      await saveProject();
    
      console.log("🗑️ Track deleted:", audioRef);
    
      wrapper.remove();
      sheetEditorEl = null;
    
      renderEditableTable(tracks);
    };

    tr.appendChild(tdDel);



    tbody.appendChild(tr);
  });

  tbody.addEventListener("dragover", (e) => {
    e.preventDefault();
  });
  
  tbody.addEventListener("drop", (e) => {
    e.preventDefault();
  
    const targetRow = e.target.closest("tr");
    if (!targetRow) return;
  
    const targetIndex = [...tbody.children].indexOf(targetRow);
  
    if (dragIndex === null || targetIndex === -1 || dragIndex === targetIndex) return;
  
    const song = songs[currentSongIndex];
    if (!song) return;
  
    const moved = song.tracks.splice(dragIndex, 1)[0];
    song.tracks.splice(targetIndex, 0, moved);
  
saveProject();
  
    wrapper.remove();
    sheetEditorEl = null;
  
    renderEditableTable(songs[currentSongIndex].tracks);
  
    dragIndex = null;
  });

  table.appendChild(tbody);
  wrapper.appendChild(table);
  document.body.appendChild(wrapper);

  
}
function handleLiveUpdate(track) {
  if (!audioCtx) return;

  const song = songs[currentSongIndex];
  if (!song) return;

  let activeTrack = null;
let nextTrack = null;

if (trackSettingsMode && trackSettingsIndex !== null) {
  activeTrack = song.tracks[trackSettingsIndex];
} else {
  const activeIndex = padsList.indexOf(activePadEl);
  const queuedIndex = padsList.indexOf(queuedPadEl);

  activeTrack =
    activeIndex !== -1
      ? song.tracks[activeIndex]
      : null;

  nextTrack =
    queuedIndex !== -1
      ? song.tracks[queuedIndex]
      : null;
}

  const bpm = toNumber(track.bpm) || tempo;
  const baseBars = toNumber(track.bars) || 1;
  const repeat = toNumber(track.repeat) || 1;
  const bars = baseBars;
  const signature = toNumber(track.signature) || 4;
  const startAtOffset = toNumber(track.start_at);
  const baseDuration = (60 / bpm) * signature * bars;


  // =========================
  // ACTIVE TRACK LIVE UPDATE
  // =========================
  if (track === activeTrack && source) {
    const restartTime = getNextBeatTime();

    const newSource = audioCtx.createBufferSource();
    newSource.buffer = source.buffer;

   if (quantizeMode === "NONE") {
  newSource.loop = false;
} else {
  newSource.loop = true;
  newSource.loopStart = startAtOffset;
  newSource.loopEnd = startAtOffset + baseDuration;
}

    const newGain = audioCtx.createGain();
    newGain.gain.value = 1;

    newSource.connect(newGain);
    newGain.connect(audioCtx.destination);

    newSource.start(restartTime, startAtOffset);

    try { source.stop(restartTime); } catch (e) {}

    source = newSource;
    currentGain = newGain;

    tempo = bpm;
    currentStartAt = restartTime;
    currentDuration = baseDuration;
    currentRepeat = repeat;
    currentRepeatIndex = 0;
    nextNoteTime = restartTime;
    lastSwitchTime = 0;

    updateActivePadBPM(bpm);
  }

  // =========================
  // QUEUED TRACK LIVE UPDATE
  // =========================
  if (track === nextTrack && queuedTrack) {
    queuedTrack.bpm = bpm;
    queuedTrack.bars = bars;
    queuedTrack.repeat = repeat;
    queuedTrack.signature = signature;
    queuedTrack.startAtOffset = startAtOffset;
    queuedTrack.fadeTime = toNumber(track.fadeintime) || 0;
        queuedTrack.fadeTime = track.fadeintime; 
  }

  // =========================
// AUTOPLAY LIVE UPDATE
// =========================
if (track === activeTrack) {
  const val = track.autoplay === "" || track.autoplay == null
  ? 1
  : toNumber(track.autoplay);

  if (val === 0 && sequenceMode) {
    sequenceMode = false;

    if (queuedPadEl) {
      queuedPadEl.classList.remove("queued");
      queuedPadEl = null;
    }

    queuedTrack = null;

    updateSeqPad();
  }
}
}

function renderSong() {
  resetApp(false);

  if (!songs.length) {
    document.body.innerHTML = `<div style="color:white;padding:20px;">No songs found</div>`;
    return;
  }

  createTopBar();
  createTopMenu();

  const grid = document.createElement("div");
  grid.className = "pad-grid";
  document.body.appendChild(grid);

  if (viewMode === "menu") {
    buildSongPads(grid); // 🔥 SONGS
  } else {
    const song = songs[currentSongIndex];
    if (!song) return;

    if (sampleLibraryMode) {

      buildSampleLibraryPads(grid);
    
    } else if (trackSettingsMode) {
    
      const track = song.tracks[trackSettingsIndex];
    
      buildTrackSettingsPads(
        grid,
        track,
        trackSettingsIndex
      );
    
    } else if (trackEditMode) {
    
      buildTrackEditPads(
        grid,
        song.tracks
      );
    
    } else {
    
      buildPads(
        grid,
        song.tracks
      );
    
    }
    // table len v song view
    if (sheetEditorEl && sheetEditorEl.style.display !== "none") {
      sheetEditorEl.remove();
      sheetEditorEl = null;
      renderEditableTable(song.tracks);
    }
  }
  //  AUTO FIX po render
  if (sequenceMode && viewMode === "song" && padsList.length && !source) {
      setTimeout(() => {
   if (activePadEl) {
      const currentIndex = padsList.indexOf(activePadEl);
      let nextIndex = currentIndex + 1;
      if (nextIndex >= padsList.length) nextIndex = 0;

      queuePadByIndex(nextIndex);
    }
  }, 50);
}
if (viewMode === "menu") {
  selectedPadIndex = selectedSongIndex;
} else {
  selectedPadIndex = selectedTrackIndex;
}
updatePadSelection();
createTableButton();
}

function updatePadUI(track) {
  const song = songs[currentSongIndex];
  if (!song) return;

  const index = song.tracks.indexOf(track);
  if (index === -1) return;

  const pad = padsList[index];
  if (!pad) return;

  const bpm = toNumber(track.bpm) || tempo;
  const baseBars = toNumber(track.bars) || 1;
  const repeat = toNumber(track.repeat) || 1;
  const signature = toNumber(track.signature) || 4;

  const name = String(track.name ?? "");

  const safeName = isOnlyNumber(name) ? "" : name;

const trackName =
  safeName.trim() !== ""
    ? safeName
    : getFileName(track.mp3);
     

  pad.querySelector(".pad-title").textContent = trackName;
  pad.querySelector(".pad-info").textContent =
    `${bpm} - ${baseBars} (${repeat}x) - ${signature}/4`;
}

// =======================
// GROUP TRACKS BY SONG
// =======================
function groupTracksBySong(tracks) {
  const map = {};
  const order = [];

  tracks.forEach((track) => {
    if (!track.mp3) return;

    const key = (track.song || "Default").toString().trim() || "Default";

    if (!map[key]) {
      map[key] = {
        title: key,
        tracks: []
      };
      order.push(key);
    }

    map[key].tracks.push(track);
  });

  return order.map((key) => map[key]);
}

// =======================
// GLOBALS
// =======================

let quantizeMode = "BAR"; // BAR | BEAT | NONE

let selectedPadIndex = 0;

let selectedSongIndex = 0;
let selectedTrackIndex = 0;

let clickOffset = 0.07; // v sekundách


let updateMetroPadFn = null;
let padsList = [];

let songs = [];
let currentSongIndex = 0;

let sequenceMode = false;
let autoplayResumeOnce = false;
let lastSwitchTime = 0;

let queuedPadEl = null;
let activePadEl = null;

let currentGain = null;

let metronomeMuted = true;
let metronomeVolume = parseFloat(localStorage.getItem("metroVol")) || 0.2;

let audioCtx = null;
let source = null;

const bufferCache = new Map();

let tempo = 120;
let nextNoteTime = 0;
let schedulerTimer = null;

let queuedTrack = null;
let isMonitoring = false;

let currentStartAt = 0;
let currentDuration = 0;

let currentRepeat = 1;
let currentRepeatIndex = 0;

let currentSignature = 4;
let currentBars = 1;

let metroCounterEl = null;

function updatePadSelection() {
  padsList.forEach((p, i) => {
    p.classList.toggle("selected", i === selectedPadIndex);
  });
}

// =======================
// COUNTER
// =======================

function getCurrentBeatInfo() {
  if (!audioCtx || !source) return null;

  const beatDuration = 60 / tempo;
  const now = audioCtx.currentTime;
  const elapsed = now - currentStartAt;

  if (elapsed < 0) return null;

  const totalBeats = Math.floor(elapsed / beatDuration);

  const beatsPerLoop = currentSignature * currentBars;
  const totalLoopBeats = beatsPerLoop * currentRepeat;

  const loopBeat = totalBeats % totalLoopBeats;

  const bar = Math.floor(loopBeat / currentSignature) + 1;
  const beat = (loopBeat % currentSignature) + 1;

  return { bar, beat };
}

function updatePadCounters() {
  if (!activePadEl) return;

  const info = getCurrentBeatInfo();
  if (!info) return;

  const counterEl = activePadEl.querySelector(".pad-counter");
  if (!counterEl) return;

  counterEl.textContent = `${info.bar}|${info.beat}`;   

  requestAnimationFrame(updatePadCounters);
}

let seqPad = null;

function updateSeqPad() {
  if (!seqPad) return;

  seqPad.classList.toggle("seq-on", sequenceMode);

  seqPad.innerHTML = `
  <div class="pad-key playstop">▶</div>
    <div class="pad-title">AUTO</div>
    <div class="pad-info">${sequenceMode ? "ON" : "OFF"}</div>  
  `;
}

function queuePadByIndex(index) {
  const nextPad = padsList[index];
  const nextTrackData = songs[currentSongIndex]?.tracks[index];

  if (!nextPad || !nextTrackData) return;

  if (queuedPadEl) queuedPadEl.classList.remove("queued");

  nextPad.classList.add("queued");
  queuedPadEl = nextPad;

  loadAudio(nextTrackData.mp3).then(buffer => {
    queuedTrack = {
      buffer,
      bpm: toNumber(nextTrackData.bpm) || tempo,
      bars: toNumber(nextTrackData.bars) || 1,
repeat: toNumber(nextTrackData.repeat) || 1,
repeatIndex: 0,
            signature: toNumber(nextTrackData.signature) || 4,
      startAtOffset: toNumber(nextTrackData.start_at),
      fadeTime: toNumber(nextTrackData.fadeintime) || 0,
      switchTime: null
    };
  });
}


function toggleSequence() {
  sequenceMode = !sequenceMode;
  lastSwitchTime = 0;

  // =========================
  // AUTO OFF
  // =========================
  if (!sequenceMode) {
    autoplayResumeOnce = false;

    if (queuedPadEl) {
      queuedPadEl.classList.remove("queued");
      queuedPadEl = null;
    }

    queuedTrack = null;

    updateSeqPad();
    return;
  }

  // =========================
  // AUTO ON
  // =========================

  const currentIndex = padsList.indexOf(activePadEl);
  const activeTrack = getCurrentActiveTrack();

  const autoplayVal =
    activeTrack?.autoplay === "" ||
    activeTrack?.autoplay == null
      ? 1
      : toNumber(activeTrack.autoplay);

  // Ručne zapnuté AUTO na AUTOPLAY OFF tracku:
  // dovolíme z neho jeden prechod na ďalší track.
  autoplayResumeOnce =
    !!activeTrack &&
    autoplayVal === 0 &&
    currentIndex !== -1;

  updateSeqPad();

  // Niečo už hrá -> priprav ďalší track
  if (source && activePadEl) {
    let nextIndex = currentIndex + 1;

    if (nextIndex >= padsList.length) {
      nextIndex = 0;
    }

    queuePadByIndex(nextIndex);
  }

  // Nič nehrá -> spusti prvý pad
  if (!source && padsList.length) {
    padsList[0].click();
  }
}

// =======================
// AUDIO
// =======================
async function saveProject() {
  const data = {
    version: 1,
    updatedAt: Date.now(),
    songs: songs
  };

  // LOCAL
  const localDb = await openDB();
  const tx = localDb.transaction("projects", "readwrite");

  await new Promise((resolve, reject) => {
    const req = tx
    .objectStore("projects")
    .put(data, getLocalProjectKey());
        req.onsuccess = () => resolve();
    req.onerror = () => reject(req.error);
  });

  // CLOUD
  if (currentUser && navigator.onLine) {
    try {
      const projectRef = doc(
        db,
        "users",
        currentUser.uid,
        "projects",
        "main"
      );

      await setDoc(projectRef, data);

    //  console.log("☁️ Project saved");
    } catch (err) {
      console.error("Cloud save failed:", err);
    }
  }
}
async function loadProject() {
  let localData = null;
  let cloudData = null;

  // =========================
  // LOCAL
  // =========================
  try {
    const localDb = await openDB();
    const tx = localDb.transaction("projects", "readonly");
    const req = tx
    .objectStore("projects")
    .get(getLocalProjectKey());

    localData = await new Promise((resolve) => {
      req.onsuccess = () => resolve(req.result || null);
      req.onerror = () => resolve(null);
    });
  } catch (err) {
    console.error("Local load failed:", err);
  }

  // =========================
  // CLOUD
  // =========================
  if (currentUser && navigator.onLine) {
    try {
      const projectRef = doc(
        db,
        "users",
        currentUser.uid,
        "projects",
        "main"
      );

      const snap = await getDoc(projectRef);

      if (snap.exists()) {
        cloudData = snap.data();
      }
    } catch (err) {
      console.error("Cloud load failed:", err);
    }
  }

  // =========================
  // POROVNANIE
  // =========================

  // nič v cloude
  if (!cloudData) {
    if (localData && currentUser && navigator.onLine) {
      try {
        await setDoc(
          doc(db, "users", currentUser.uid, "projects", "main"),
          localData
        );
       // console.log("☁️ Local project uploaded");
      } catch (err) {
        console.error(err);
      }
    }

    return localData;
  }

  // nič lokálne
  if (!localData) {
    await saveProjectToLocal(cloudData);
    return cloudData;
  }

  const localTime = Number(localData.updatedAt || 0);
  const cloudTime = Number(cloudData.updatedAt || 0);

  // LOCAL je novší
  if (localTime > cloudTime) {
    try {
      await setDoc(
        doc(db, "users", currentUser.uid, "projects", "main"),
        localData
      );

   //   console.log("⬆️ Local newer → uploaded");
    } catch (err) {
      console.error(err);
    }

    return localData;
  }

  // CLOUD je novší alebo rovnaký
  await saveProjectToLocal(cloudData);

//  console.log("⬇️ Cloud newer → downloaded");

  return cloudData;

  
}

async function saveProjectToLocal(data) {
  const localDb = await openDB();
  const tx = localDb.transaction("projects", "readwrite");

  return new Promise((resolve, reject) => {
    const req = tx
      .objectStore("projects")
      .put(data, getLocalProjectKey());

    req.onsuccess = () => resolve();
    req.onerror = () => reject(req.error);
  });
}

async function ensureAudioContext() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  if (audioCtx.state === "suspended") {
    await audioCtx.resume();
  }
}

async function loadAudio(url) {
  if (bufferCache.has(url)) {
    return bufferCache.get(url);
  }

  // 🔥 skús DB
  const data = await loadFromDB(url);

  if (!data) {
    throw new Error("NOT_CACHED");
  }

  const copy = data.slice(0);
  const decoded = await audioCtx.decodeAudioData(copy);

  bufferCache.set(url, decoded);
  return decoded;
}

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open("samplton-db", 2);

req.onupgradeneeded = () => {
  const db = req.result;

  if (!db.objectStoreNames.contains("files")) {
    db.createObjectStore("files"); // audio
  }

  if (!db.objectStoreNames.contains("projects")) {
    db.createObjectStore("projects"); // 🔥 NOVÉ
  }
};

    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function saveToDB(key, buffer) {
  const db = await openDB();
  const tx = db.transaction("files", "readwrite");
  tx.objectStore("files").put(buffer, key);
}

async function loadFromDB(key) {
  const db = await openDB();
  const tx = db.transaction("files", "readonly");
  const req = tx.objectStore("files").get(key);

  return new Promise((resolve, reject) => {
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}
// =======================
// METRONOME
// =======================
function scheduler() {
  while (nextNoteTime < audioCtx.currentTime + 0.05) {
    scheduleClick(nextNoteTime + clickOffset);
    nextNoteTime += 60 / tempo;
  }
  schedulerTimer = setTimeout(scheduler, 25);
}

function scheduleClick(time) {
  if (metronomeMuted) return;

  const osc = audioCtx.createOscillator();
  const gain = audioCtx.createGain();

  osc.frequency.value = 1000;

  gain.gain.setValueAtTime(Math.max(0.001, metronomeVolume), time);
  gain.gain.exponentialRampToValueAtTime(0.001, time + 0.05);

  osc.connect(gain);
  gain.connect(audioCtx.destination);

  osc.start(time);
  osc.stop(time + 0.05);
}


// =======================
// DOWNLOAD SONG
// =======================

async function prepareSong(tracks) {
  await ensureAudioContext();

  for (const t of tracks) {

    // 🔥 AK UŽ JE V RAM → SKIP
    if (bufferCache.has(t.mp3)) {
      continue;
    }

    const data = await loadFromDB(t.mp3);
    if (!data) continue;

    const copy = data.slice(0);
    const decoded = await audioCtx.decodeAudioData(copy);

    bufferCache.set(t.mp3, decoded);
  }
}

async function cacheSongTracks(tracks) {

  for (const t of tracks) {
    if (!t.mp3) continue;

    // už máme LOCAL
    const existing = await loadFromDB(t.mp3);

    if (existing) {
      continue;
    }

    try {
      let res;

      // =========================
      // R2 AUDIO
      // =========================
      if (isR2Audio(t.mp3)) {

        if (!currentUser) {
          throw new Error("NO_USER");
        }

        const token =
          await currentUser.getIdToken();

        const fileName =
          getR2FileName(t.mp3);

        res = await fetch(
          `${R2_API}/audio/${encodeURIComponent(fileName)}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

      }

      // =========================
      // STARÉ URL AUDIO
      // =========================
      else {
        res = await fetch(t.mp3);
      }

      if (!res.ok) {
        throw new Error(
          `DOWNLOAD_${res.status}`
        );
      }

      const buffer = await res.arrayBuffer();

      await saveToDB(
        t.mp3,
        buffer.slice(0)
      );

     // console.log("⬇️ Audio cached:", t.mp3);

    } catch (e) {
      console.warn(
        "❌ Audio cache fail:",
        t.mp3,
        e
      );
    }
  }
}


// =======================
// START FIRST TRACK
// =======================
async function startFirstTrack(url, bpm, bars, signature = 4, startAtOffset = 0, repeat = 1) {
  const buffer = await loadAudio(url);


  currentSignature = signature;
currentBars = bars;

const baseDuration = (60 / bpm) * signature * bars;
const startAt =
  quantizeMode === "NONE"
    ? audioCtx.currentTime
    : getNextBeatTime();
      source = audioCtx.createBufferSource();
  source.buffer = buffer;

  const gainNode = audioCtx.createGain();
  gainNode.gain.value = 1;

  source.connect(gainNode);
  gainNode.connect(audioCtx.destination);

  currentGain = gainNode;

  const loopStart = startAtOffset;

  if (quantizeMode === "NONE") {
    source.loop = false;
  } else {
    source.loop = true;
    source.loopStart = loopStart;
    source.loopEnd = loopStart + baseDuration;
  }

  source.start(startAt, loopStart);

  tempo = bpm;
  nextNoteTime = startAt;
  if (schedulerTimer) {
    clearTimeout(schedulerTimer);
  }
  
  scheduler();

  currentStartAt = startAt;
  currentDuration = baseDuration;
  currentRepeat = repeat;
  currentRepeatIndex = 0;

  if (!isMonitoring) {
    isMonitoring = true;
    monitorLoop();
  }

  updateActivePadBPM(bpm);
  updatePadCounters();

  //  AUTO FIX
if (sequenceMode) {
  const currentIndex = padsList.indexOf(activePadEl);
  let nextIndex = currentIndex + 1;

  if (nextIndex >= padsList.length) nextIndex = 0;

  queuePadByIndex(nextIndex);
}
}

// =======================
// LOOP MONITOR (QUEUE)
// =======================
function monitorLoop() {
  function check() {
    if (!source || !audioCtx) return;

    const now = audioCtx.currentTime;
    const elapsed = now - currentStartAt;

    const loopsPassed = Math.floor(elapsed / currentDuration);

    // 🔥 iba každý N-ty loop (repeat)
// 🔥 repeat iba keď je autoplay ON
if (sequenceMode && (loopsPassed + 1) % currentRepeat !== 0) {  
  return requestAnimationFrame(check);
}

    const nextBoundary = currentStartAt + (loopsPassed + 1) * currentDuration;
    
    // ak queuedTrack má vlastný switchTime, použijeme ten
    const targetSwitchTime = queuedTrack?.switchTime || nextBoundary;
    const timeToBoundary = targetSwitchTime - now;

    const activeTrackData = getCurrentActiveTrack();

const autoplayVal = activeTrackData?.autoplay === "" || activeTrackData?.autoplay == null
  ? 1
  : toNumber(activeTrackData.autoplay);

  if (
    sequenceMode &&
    autoplayVal === 0 &&
    !autoplayResumeOnce
  ) {
    sequenceMode = false;
  
    if (queuedPadEl) {
      queuedPadEl.classList.remove("queued");
      queuedPadEl = null;
    }
  
    queuedTrack = null;
  
    updateSeqPad();
    requestAnimationFrame(check);
    return;
  }

    
    if (timeToBoundary < 0.1 && queuedTrack && targetSwitchTime !== lastSwitchTime) {
                  const q = queuedTrack;
      queuedTrack = null;


      currentSignature = q.signature;
      currentBars = q.bars;


      const newSource = audioCtx.createBufferSource();
      newSource.buffer = q.buffer;
      
      const newDuration = (60 / q.bpm) * q.signature * q.bars;
      const loopStart = q.startAtOffset;
      
      if (quantizeMode === "NONE") {
        newSource.loop = false;
      } else {
        newSource.loop = true;
        newSource.loopStart = loopStart;
        newSource.loopEnd = loopStart + newDuration;
      }

      const newGain = audioCtx.createGain();
      
      newSource.connect(newGain);
      newGain.connect(audioCtx.destination);
      
      newSource.start(targetSwitchTime, loopStart);
      
      const fadeTime = q.fadeTime || 0;

      if (fadeTime > 0) {
        newGain.gain.setValueAtTime(0.001, targetSwitchTime);
        newGain.gain.linearRampToValueAtTime(
          1,
          targetSwitchTime + fadeTime
        );
      } else {
        newGain.gain.value = 1;
      }
      
      // starý track
      if (fadeTime > 0 && currentGain) {
        currentGain.gain.setValueAtTime(1, targetSwitchTime);
        currentGain.gain.linearRampToValueAtTime(
          0,
          targetSwitchTime + fadeTime
        );
      
        source.stop(targetSwitchTime + fadeTime);
      } else {
        source.stop(targetSwitchTime);
      }

      source = newSource;
      currentGain = newGain;
      currentRepeat = q.repeat || 1;
currentRepeatIndex = 0;


      if (activePadEl) activePadEl.classList.remove("active");

      if (queuedPadEl) {
        queuedPadEl.classList.remove("queued");
        queuedPadEl.classList.add("active");

        activePadEl = queuedPadEl;
        queuedPadEl = null;
        updateActivePadBPM(q.bpm);
        const activeIndex =
  padsList.indexOf(activePadEl);

const activeTrack =
  songs[currentSongIndex]?.tracks[activeIndex];

updateTrackSubtitle(activeTrack);

        // 🔥 AUTO SEQUENCE MODE
if (sequenceMode) {
  const currentIndex = padsList.indexOf(activePadEl);

  if (currentIndex !== -1) {
    let nextIndex = currentIndex + 1;

    if (nextIndex >= padsList.length) {
      nextIndex = 0; // loop späť na začiatok
    }

    const nextPad = padsList[nextIndex];

    if (nextPad) {
      nextPad.classList.add("queued");
    
      queuedPadEl = nextPad;
    
      const nextTrackData = songs[currentSongIndex].tracks[nextIndex];
    
      loadAudio(nextTrackData.mp3).then(buffer => {
        queuedTrack = {
          buffer,
          bpm: toNumber(nextTrackData.bpm) || tempo,
          bars: toNumber(nextTrackData.bars) || 1,
repeat: toNumber(nextTrackData.repeat) || 1,
repeatIndex: 0,
                    signature: toNumber(nextTrackData.signature) || 4,
          startAtOffset: toNumber(nextTrackData.start_at),
          fadeTime: toNumber(nextTrackData.fadeintime) || 0,
          switchTime: null
        
        };
      });
    }
  }
}
      }



      tempo = q.bpm;
currentStartAt = targetSwitchTime;
      currentDuration = newDuration;
      lastSwitchTime = targetSwitchTime;
      autoplayResumeOnce = false;
    }

    requestAnimationFrame(check);
  }

  check();
}

// =======================
// TOP BAR MENU
// =======================

async function openLegalSection(key, returnToMenu = true) {
  const section = legal[key];

  if (!section) return;

  await sampltonAlert({
    title: section.title,
    width: 700,

    html: `
      <div
        style="
          text-align:left;
          line-height:1.65;
          max-height:60vh;
          overflow-y:auto;
          padding-right:10px;
        "
      >
        ${section.content
          .map(item => `<p>${item}</p>`)
          .join("")}
      </div>
    `,

    confirmButtonText: returnToMenu ? "BACK" : "CLOSE"
  });

  if (returnToMenu) {
    await openLegalMenu();
  }
}

async function openLegalMenu() {
  const result = await sampltonAlert({
    title: "Legal & Privacy",

    html: `
      <div style="
        display:flex;
        flex-direction:column;
        gap:10px;
        margin-top:15px;
      ">

        <button
          class="legal-menu-btn"
          data-legal="terms"
        >
          TERMS & CONDITIONS
        </button>

        <button
          class="legal-menu-btn"
          data-legal="privacy"
        >
          PRIVACY POLICY
        </button>

        <button
          class="legal-menu-btn"
          data-legal="cookies"
        >
          COOKIES & LOCAL STORAGE
        </button>

        <button
          class="legal-menu-btn"
          data-legal="contact"
        >
          CONTACT
        </button>

      </div>
    `,

    showConfirmButton: false,
    showCloseButton: true,

    didOpen: () => {
      document
        .querySelectorAll(".legal-menu-btn")
        .forEach(btn => {

          btn.onclick = () => {
            const key =
              btn.dataset.legal;

            Swal.close();

            setTimeout(() => {
              openLegalSection(key);
            }, 100);
          };

        });
    }
  });

  return result;
}

function legalCheckoutText() {
  return `
    <p style="
      font-size:12px;
      opacity:0.85;
      margin-top:18px;
    ">
      By continuing, you confirm that you have read and accepted the
      <a
        href="#"
        class="checkout-terms-link"
        style="
          color:#fff;
          text-decoration:underline;
          font-weight:bold;
        "
      >
        Terms & Conditions
      </a>
      and
      <a
        href="#"
        class="checkout-privacy-link"
        style="
          color:#fff;
          text-decoration:underline;
          font-weight:bold;
        "
      >
        Privacy Policy
      </a>.
    </p>
  `;
}

function createTopMenu() {
  const wrapper = document.createElement("div");
  wrapper.className = "top-bar-wrapper";

  // 🔹 LEFT TOGGLE BUTTON
  const toggleBtn = document.createElement("div");
  toggleBtn.className = "pad-mini";
  toggleBtn.innerHTML = "☰";

  // 🔹 MENU PANEL
  const panel = document.createElement("div");
  panel.className = "top-menu-panel hidden";


  const resetKeepAudioBtn = createMiniBtn("Reset app", async () => {
    const result = await sampltonAlert({
      title: "Reset app?",
      text: "Your audio files will not be deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "RESET",
      cancelButtonText: "CANCEL"
    });
    
    if (!result.isConfirmed) return;
    
    await resetAppKeepAudio();
  });

  const userBtn = document.createElement("div");
  userBtn.className = "pad-mini user-pad";
  
  if (currentUser) {
    userBtn.innerHTML = `
      ${
        currentUser.photoURL
          ? `
            <img
              src="${currentUser.photoURL}"
              class="user-photo"
              referrerpolicy="no-referrer"
            >
          `
          : `<div class="user-photo-fallback"></div>`
      }
  
      <div class="user-pad-name">
        ${currentUser.displayName || "User"}
      </div>
  
      <div class="user-pad-status">
        ${isPro ? "PRO" : "FREE"}
      </div>
  
      <div class="user-pad-storage">
        loading...
      </div>
    `;
  
    // načítaj reálne využitie R2 z Workera
    getStorageInfo().then((storage) => {
      if (!storage) return;
  
      const storageEl =
        userBtn.querySelector(".user-pad-storage");
  
      if (!storageEl) return;
  
      const usedMB =
        storage.used / 1024 / 1024;
  
      const limitMB =
        storage.limit / 1024 / 1024;
  
      storageEl.textContent =
        `${usedMB.toFixed(1)} / ${limitMB.toFixed(0)} MB`;
    });
  
  } else {
    userBtn.innerHTML = `
      <div class="user-photo-fallback">👤</div>
      <div class="user-pad-name">Not signed in</div>
    `;
  }

  const userPhoto = userBtn.querySelector(".user-photo");

if (userPhoto) {
  userPhoto.onerror = () => {
    userPhoto.remove();

    const fallback = document.createElement("div");
    fallback.className = "user-photo-fallback";
    fallback.textContent = "👤";

    userBtn.prepend(fallback);
  };
}
  
  const authBtn = createMiniBtn(
    currentUser ? "Logout" : "Login",
    async () => {
      if (currentUser) {
        await signOut(auth);
        return;
      }
  
      const isMobile =
        /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  
      try {
        if (isMobile) {
          await signInWithRedirect(auth, provider);
        } else {
          await signInWithPopup(auth, provider);
        }
      } catch (error) {
        console.error("Google login error:", error);
        alert(error.code + "\n" + error.message);
      }
    }
  );

  const buyStorageBtn = createMiniBtn(
    "+100 MB / 10 € / YEAR",
  
    async () => {
  
      if (!currentUser) {
        await sampltonAlert({
          title: "Sign in required",
          text: "Please sign in first.",
          icon: "info"
        });
  
        return;
      }
  
      if (!isPro) {
        await sampltonAlert({
          title: "PRO required",
          text: "Extra storage is available for PRO users only.",
          icon: "info"
        });
  
        return;
      }
  
      const confirm = await sampltonAlert({
        title: "Extra Cloud Storage",
        icon: "info",
      
        html: `
          <div style="text-align:left; line-height:1.7;">
      
            <p style="
              font-size:24px;
              font-weight:bold;
              text-align:center;
            ">
              10 € / YEAR
            </p>
      
            <p>
              <b>You will receive:</b>
            </p>
      
            <p>
              ✓ +100 MB cloud storage<br>
              ✓ Valid for 1 year
            </p>
      
            <hr style="
              border:0;
              border-top:1px solid #333;
              margin:18px 0;
            ">
      
            ${legalCheckoutText()}
      
          </div>
        `,
      
        showCancelButton: true,
        confirmButtonText: "CONTINUE TO PAYMENT",
        cancelButtonText: "CANCEL",
      
        didOpen: () => {
      
          const termsLink =
            document.querySelector(".checkout-terms-link");
      
          const privacyLink =
            document.querySelector(".checkout-privacy-link");
      
          termsLink?.addEventListener("click", async (e) => {
            e.preventDefault();
            e.stopPropagation();
      
            Swal.close();
      
            await openLegalSection("terms", false);
      
            buyStorageBtn.click();
          });
      
          privacyLink?.addEventListener("click", async (e) => {
            e.preventDefault();
            e.stopPropagation();
      
            Swal.close();
      
            await openLegalSection("privacy", false);
      
            buyStorageBtn.click();
          });
        }
      });

      if (!confirm.isConfirmed) return;
  
      try {
  
        const token =
          await currentUser.getIdToken();
  
        const res = await fetch(
          `${R2_API}/create-storage-checkout`,
          {
            method: "POST",
  
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );
  
        const data =
          await res.json();
  
        if (
          !res.ok ||
          !data.ok ||
          !data.url
        ) {
  
          console.error(
            "Storage checkout failed:",
            data
          );
  
          await sampltonAlert({
            title: "Checkout failed",
            text: "Storage checkout could not be started.",
            icon: "error"
          });
  
          return;
        }
  
        window.location.href =
          data.url;
  
      } catch (err) {
  
        console.error(
          "Storage checkout error:",
          err
        );
  
        await sampltonAlert({
          title: "Checkout failed",
          text: "Storage checkout could not be started.",
          icon: "error"
        });
      }
    }
  );

      // --- BUTTONY DO PANELU ---

      const prepareAllBtn = createMiniBtn(
        "Prepare All Songs",
        async () => {
          try {
            prepareAllBtn.innerHTML = "Preparing...";
      
            await ensureAudioContext();
      
            for (let songIndex = 0; songIndex < songs.length; songIndex++) {
              const song = songs[songIndex];
      
              // song pad v menu
              const songPad = padsList[songIndex];
      
              if (songPad) {
                songPad.classList.add("loading");
              }
      
              const tracks = (song.tracks || []).filter(
                track => track.mp3
              );
      
              for (const track of tracks) {
      
                // už pripravené v RAM
                if (bufferCache.has(track.mp3)) {
                  continue;
                }
      
                // skús lokálnu IndexedDB
                let data = await loadFromDB(track.mp3);
      
                // ak lokálne chýba, stiahni z R2
                if (!data && navigator.onLine) {
                  await cacheSongTracks([track]);
                  data = await loadFromDB(track.mp3);
                }
      
                if (!data) {
                  console.warn(
                    "Track not available:",
                    track.mp3
                  );
                  continue;
                }
      
                const copy = data.slice(0);
      
                const decoded =
                  await audioCtx.decodeAudioData(copy);
      
                bufferCache.set(
                  track.mp3,
                  decoded
                );
              }
      
              // song hotový
              if (songPad) {
                songPad.classList.remove("loading");
              }
            }
      
            prepareAllBtn.innerHTML = "Songs Ready";
      
          } catch (err) {
            console.error(
              "Prepare all failed:",
              err
            );
      
            // odstráň loading zo všetkých song padov
            padsList.forEach(pad => {
              pad.classList.remove("loading");
            });
      
            prepareAllBtn.innerHTML =
              "Prepare All Songs";
          }
        }
      );

      const prepareInfoBtn = document.createElement("div");
      prepareInfoBtn.className = "menu-info-btn";
      prepareInfoBtn.textContent = "+";
      
      prepareInfoBtn.onclick = async (e) => {
        e.preventDefault();
        e.stopPropagation();
      
        await sampltonAlert({
          title: "Prepare All Songs",
          icon: "info",
          html: `
            <div style="text-align:left; line-height:1.6;">
              <p>
                Normally, each song is prepared when you open it.
              </p>
      
              <p>
                <b>Prepare All Songs</b> loads and decodes all tracks
                from all songs in advance.
              </p>
      
              <p>
                This is useful before a live performance,
                because every song will already be ready to play.
              </p>
            </div>
          `,
          confirmButtonText: "OK"
        });
      };
      
      prepareAllBtn.appendChild(prepareInfoBtn);


  const exportBtn = createMiniBtn("Export Project", () => {
    const name = prompt("Zadaj názov súboru:", "project");
    if (!name) return;
  
    const safeName = name
      .trim()
      .replace(/\s+/g, "_")
      .replace(/[^\w-]/g, "");
  
    const finalName = safeName || "project";
  
    // 🔥 DATETIME (short)
    const now = new Date();
    const pad = (n) => String(n).padStart(2, "0");
  
    const dateTime =
      now.getFullYear().toString().slice(2) +
      pad(now.getMonth() + 1) +
      pad(now.getDate()) +
      "_" +
      pad(now.getHours()) +
      pad(now.getMinutes());
  
    const data = {
      version: 1,
      songs: songs
    };
  
    const blob = new Blob(
      [JSON.stringify(data, null, 2)],
      { type: "application/samplton+json" }
    );
  
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `${finalName}_${dateTime}.samplton`;
    a.click();
  
    // cleanup
    setTimeout(() => URL.revokeObjectURL(a.href), 1000);
  });
  
  const importBtn = createMiniBtn("Import Project", () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".samplton,application/json";
  
    input.onchange = (e) => {
      const file = e.target.files[0];
      const reader = new FileReader();
  
      reader.onload = async () => {
        try {
          const parsed = JSON.parse(reader.result);
      
          // 🔥 1. RESET CELÉHO APP STATE
          resetApp(true);   // ← toto je kľúčové
      
          // 🔥 2. RESET CACHE (dôležité!)
          bufferCache.clear();
      
          // 🔥 3. LOAD DATA
          if (parsed.songs) {
            songs = parsed.songs;
          } else {
            songs = groupTracksBySong(parsed);
          }
      
          currentSongIndex = 0;
          selectedSongIndex = 0;
          selectedTrackIndex = 0;
      
          // 🔥 4. SAVE
          await saveProject();
      
        // 🔥 5. DOWNLOAD R2 AUDIO + PREPARE
const allTracks = songs.flatMap(s => s.tracks || []);

// najprv stiahni chýbajúce audio z R2 do IndexedDB
await cacheSongTracks(allTracks);

// až potom ho dekóduj do RAM
await prepareSong(allTracks);
      
          // 🔥 6. VIEW RESET
          viewMode = "menu";
      
          // 🔥 7. RENDER CLEAN
          renderSong();
      
        } catch (err) {
          console.error(err);
          await sampltonAlert({
            title: "Invalid file",
            text: "The selected project file could not be loaded.",
            icon: "error"
          });
        }
      };
      reader.readAsText(file);
    };
  
    input.click();
  });

  const importExportBtn = createMiniBtn(
    "Import / Export",
    async () => {
  
      const result = await sampltonAlert({
        title: "Import / Export",
  
        html: `
          <div style="
            display:flex;
            flex-direction:column;
            gap:10px;
            margin-top:15px;
          ">
            <button
              id="samplton-export-btn"
              class="legal-menu-btn"
            >
              EXPORT PROJECT
            </button>
  
            <button
              id="samplton-import-btn"
              class="legal-menu-btn"
            >
              IMPORT PROJECT
            </button>
          </div>
        `,
  
        showConfirmButton: false,
        showCloseButton: true,
  
        didOpen: () => {
  
          document
            .getElementById("samplton-export-btn")
            ?.addEventListener("click", () => {
              Swal.close();
              exportBtn.click();
            });
  
          document
            .getElementById("samplton-import-btn")
            ?.addEventListener("click", () => {
              Swal.close();
              importBtn.click();
            });
  
        }
      });
  
      return result;
    }
  );

  const importExportInfoBtn = document.createElement("div");
importExportInfoBtn.className = "menu-info-btn";
importExportInfoBtn.textContent = "+";

importExportInfoBtn.onclick = async (e) => {
  e.preventDefault();
  e.stopPropagation();

  await sampltonAlert({
    title: "Import / Export",
    icon: "info",

    html: `
      <div style="text-align:left; line-height:1.6;">

        <p>
          <b>Export Project</b> saves your current Samplton project
          as a <b>.samplton</b> file.
        </p>

        <p>
          The file contains the project structure and settings
          in <b>JSON format</b>, including songs, tracks, BPM,
          bars, start positions, repeats, notes and other settings.
        </p>

        <p>
          <b>Audio files are not stored inside the exported file.</b>
          The project keeps references to your audio stored
          in your Samplton Sample Library.
        </p>

        <p>
          <b>Import Project</b> loads a previously exported
          .samplton project back into Samplton.
        </p>

        <p>
          This can be useful for creating backups or keeping
          different versions of your project.
        </p>

      </div>
    `,

    confirmButtonText: "OK"
  });
};

importExportBtn.appendChild(importExportInfoBtn);

const loadMainBtn = createMiniBtn("Demo Project", async () => {
  const result = await sampltonAlert({
    title: "Restore Demo Project?",
    text: "This will replace the current local project with the original Samplton demo.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "RESTORE DEMO",
    cancelButtonText: "CANCEL"
  });

  if (!result.isConfirmed) return;

  songs = structuredClone(mainProject.songs);

  currentSongIndex = 0;
  selectedSongIndex = 0;
  selectedTrackIndex = 0;

  await saveProject();

  viewMode = "menu";
  renderSong();

  const allTracks = songs.flatMap(
    s => s.tracks || []
  );

  cacheSongTracks(allTracks);
  prepareSong(allTracks);
});

const newProjectBtn = createMiniBtn("New Project", async () => {

  const emptyProject = {
    version: 1,
    songs: [
      {
        title: "New Song",
        tracks: [
          {
            song: "New Song",
            name: "New Loop",
            notes: "",
            mp3: "",
            bpm: 120,
            signature: 4,
            bars: 4,
            start_at: 0.01,
            fadeintime: 0.5,
            repeat: 1,
            autoplay: 1
          }
        ]
      }
    ]
  };

  songs = emptyProject.songs;

  currentSongIndex = 0;
  selectedSongIndex = 0;
  selectedTrackIndex = 0;

  await saveProject();

  // 🔥 PRIDAŤ SEM
  const allTracks = songs.flatMap(s => s.tracks);
  await cacheSongTracks(allTracks);
  await prepareSong(allTracks);

  viewMode = "song";
trackEditMode = true;
trackSettingsMode = false;

renderSong();
});



  const installBtn = createMiniBtn("Install App", async () => {
    if (!deferredPrompt) {
      await sampltonAlert({
        title: "App unavailable",
        text: "The app is already installed or installation is not available.",
        icon: "info"
      });
      return;
    }
  
    deferredPrompt.prompt();
  
    const { outcome } = await deferredPrompt.userChoice;
  
    deferredPrompt = null;
  });

  const installInfoBtn = document.createElement("div");
installInfoBtn.className = "menu-info-btn";
installInfoBtn.textContent = "+";

installInfoBtn.onclick = async (e) => {
  e.preventDefault();
  e.stopPropagation();

 

  await sampltonAlert({
    title: "Install Samplton",
    icon: "info",
    html: `
      <div style="text-align:left; line-height:1.6;">
        <p>
          Samplton is a <b>Progressive Web App (PWA)</b>.
        </p>

        <p>
          You can install it on your <b>phone, tablet or computer</b>
          and use it like a standalone application.
        </p>

        <p>
          On desktop, install Samplton directly through
          <b>Google Chrome</b>.
        </p>

        <p>
          Once installed, Samplton can be launched from your
          home screen or applications without opening the website first.
        </p>
      </div>
    `,
    confirmButtonText: "OK"
  });
};

installBtn.appendChild(installInfoBtn);

  const keyshots = createMiniBtn("Keyshots", async () => {
    await sampltonAlert({
      title: "Keyshots",
      icon: "info",
      html: `
        <div style="text-align:left; line-height:1.8;">
          <p><b>1–9 / 0</b> → play pad</p>
          <p><b>Enter</b> → play</p>
          <p><b>R</b> → reload</p>
          <p><b>S</b> → stop</p>
          <p><b>A</b> → auto sequence</p>
          <p><b>Q</b> → quantize</p>
          <p><b>C</b> → metronome</p>
          <p><b>E</b> → edit track or songs</p>
          <p><b>F</b> → fullscreen</p>
          <p><b>← → ↑ ↓</b> → pads navigate</p>
          <p><b>Backspace</b> → menu</p>
        </div>
      `,
      confirmButtonText: "OK"
    });
  });

  const aboutBtn = createMiniBtn(
    "About Me",
    async () => {
      await sampltonAlert({
        title: "About Me",
        width: 700,
        html: `
          <div style="
            text-align:left;
            line-height:1.7;
            max-height:65vh;
            overflow-y:auto;
            padding-right:10px;
          ">
  
            <p>
              <b>Martin z Divartu</b> is based in Zvolen, Slovakia.
            </p>
  
            <p>
              It is the solo music project of Martin Ryboš, combining
              electronic music with live vocals, transverse flute,
              guitar and live looping.
            </p>
  
            <p>
              The music of Martin z Divartu moves between electronic,
              cinematic, alternative and classical influences.
            </p>
  
            <p>
              A characteristic element of the project is the combination
              of organic instruments, rhythms and electronics performed
              entirely live, without the use of a computer during the
              musical performance.
            </p>
  
            <p>
              The focus is on emotional melodies and longer compositions
              that create a story and leave space for emotion,
              atmosphere and imagination.
            </p>
  
            <p>
              Martin is also a hobby coder and developer.
              His live performances are accompanied by original visual
              projections controlled from an MPC via MIDI and routed into
              his own custom web applications.
            </p>
  
            <hr style="
              border:0;
              border-top:1px solid #333;
              margin:20px 0;
            ">
  
            <p style="text-align:center;">
              <a
                href="https://www.divart.sk/martin-z-divartu/"
                target="_blank"
                rel="noopener noreferrer"
                style="color:white;text-decoration:underline;"
              >
                divart
              </a>
            </p>
            <p style="text-align:center;">
              <a
                href="https://www.youtube.com/results?search_query=martin+z+divartu"
                target="_blank"
                rel="noopener noreferrer"
                style="color:white;text-decoration:underline;"
              >
                youtube
              </a>
            </p>
            <p style="text-align:center;">
              <a
                href="https://open.spotify.com/artist/63L3WZLlxIahjeEAZI5WCH"
                target="_blank"
                rel="noopener noreferrer"
                style="color:white;text-decoration:underline;"
              >
                spotify
              </a>
            </p>
  
          </div>
        `,
        confirmButtonText: "CLOSE"
      });
    }
  );

  const legalBtn = createMiniBtn(
    "Legal & Privacy",
    async () => {
      await openLegalMenu();
    }
  );

  panel.appendChild(userBtn);
  panel.appendChild(authBtn);
  if (!currentUser) {
    panel.appendChild(loadMainBtn);
  }
  panel.appendChild(prepareAllBtn);
 // panel.appendChild(newProjectBtn);
  // panel.appendChild(exportBtn);
  // panel.appendChild(importBtn);
  panel.appendChild(importExportBtn);
  panel.appendChild(installBtn);
 // panel.appendChild(resetKeepAudioBtn);
  panel.appendChild(keyshots); 
  if (!currentUser) {
    panel.appendChild(aboutBtn);
  }
  panel.appendChild(legalBtn);
  if (isPro) {
    panel.appendChild(buyStorageBtn);
  }  

  // 🔹 TOGGLE ACTION
  toggleBtn.onclick = () => {
    panel.classList.toggle("hidden");
  };

  // 🔹 RIGHT FULLSCREEN
  const fullscreenBtn = document.createElement("div");
  fullscreenBtn.className = "pad-mini";
  fullscreenBtn.innerHTML = "⛶";

  fullscreenBtn.onclick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleFullscreen(fullscreenBtn);
  };

  // 🔹 APPEND
  wrapper.appendChild(toggleBtn);
  wrapper.appendChild(panel);
  wrapper.appendChild(fullscreenBtn);

  document.body.appendChild(wrapper);
}

function createTableButton() {
  const btn = document.createElement("div");
  btn.className = "floating-table-btn";

  if (viewMode === "menu") {
    btn.innerHTML = songEditMode ? "✓" : "✎";

    btn.onclick = () => {
      songEditMode = !songEditMode;
      renderSong();
    };
  } else {

    // SAMPLE LIBRARY
    if (sampleLibraryMode) {
      btn.innerHTML = "✎";
  
      btn.onclick = () => {
        stopSampleLibraryPreview();
  
        sampleLibraryMode = false;
        sampleLibraryTargetTrackIndex = null;
  
        trackEditMode = true;
        trackSettingsMode = false;
  
        renderSong();
      };
  
      document.body.appendChild(btn);
      return;
    }
  
    // NORMAL SONG / TRACK EDIT
    btn.innerHTML = trackEditMode ? "✓" : "✎";
  
    btn.onclick = () => {
      trackEditMode = !trackEditMode;
      renderSong();
    };
  
}

  document.body.appendChild(btn);
}
// helper

function updateTrackSubtitle(track = null) {

  if (
    !trackSubtitleEl ||
    !document.body.contains(trackSubtitleEl)
  ) {
    trackSubtitleEl = document.createElement("div");
    trackSubtitleEl.className = "track-subtitle";
    document.body.appendChild(trackSubtitleEl);
  }

  const text = String(track?.notes || "").trim();
  const visible = track?.notesVisible === true;

  if (!visible || !text) {
    trackSubtitleEl.textContent = "";
    trackSubtitleEl.classList.remove("visible");
    return;
  }

  trackSubtitleEl.textContent = text;
  trackSubtitleEl.classList.add("visible");
}

async function getStorageInfo() {
  if (!currentUser) return null;

  try {
    const token = await currentUser.getIdToken();

    const res = await fetch(`${R2_API}/storage`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    const data = await res.json();

    if (!res.ok || !data.ok) {
      console.error("Storage info failed:", data);
      return null;
    }

  //  console.log("STORAGE:", data);

    return data;

  } catch (err) {
    console.error("Storage info error:", err);
    return null;
  }
}


function createMiniBtn(label, fn) {
  const btn = document.createElement("div");
  btn.className = "pad-mini";
  btn.innerHTML = label;
  btn.onclick = fn;
  return btn;
}


function toggleFullscreen(btn) {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen().catch(err => {
      console.error(err);
    });
    if (btn) btn.innerHTML = "⤡";
  } else {
    document.exitFullscreen();
    if (btn) btn.innerHTML = "⛶";
  }
}

// =======================
// UTILS
// =======================

function getCurrentActiveTrack() {
  const song = songs[currentSongIndex];
  if (!song) return null;

  const index = padsList.indexOf(activePadEl);
  return index !== -1 ? song.tracks[index] : null;
}

function getGridColumns() {
  if (!padsList.length) return 1;

  const firstTop = padsList[0].offsetTop;

  let cols = 0;
  for (let pad of padsList) {
    if (pad.offsetTop !== firstTop) break;
    cols++;
  }

  return cols || 1;
}


function showLoader() {
  if (document.querySelector(".loader")) return;

  const loader = document.createElement("div");
  loader.className = "loader";
  document.body.appendChild(loader);
}

function hideLoader() {
  document.querySelector(".loader")?.remove();
}

function isOnlyNumber(val) {
  return /^\d+$/.test(String(val).trim());
}

function buildSongPads(grid) {
  padsList = [];

  let index = 1;

  songs.forEach((song, i) => {
    const pad = document.createElement("div");
    pad.className = "pad";

    if (songEditMode) {
      pad.classList.add("song-edit-pad");
    }

    pad.innerHTML = `
      <div class="pad-key">${index}</div>
      <div class="pad-title"></div>
      <div class="pad-info">${song.tracks.length} tracks</div>
    `;

    const titleEl = pad.querySelector(".pad-title");
    titleEl.textContent = song.title;

    // =========================
    // EDIT MODE
    // =========================
    if (songEditMode) {

      titleEl.classList.add("song-edit-title");

      titleEl.onclick = (e) => {
        e.stopPropagation();

        titleEl.contentEditable = "true";
        titleEl.focus();

        const range = document.createRange();
        range.selectNodeContents(titleEl);

        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      };

      const finishTitleEdit = async () => {
        let val = titleEl.textContent.trim();

        if (!val || isOnlyNumber(val)) {
          val = "New Song";
        }

        song.title = val;
        titleEl.textContent = val;
        titleEl.contentEditable = "false";

        song.tracks.forEach(track => {
          track.song = val;
        });

        await saveProject();
      };

      titleEl.onblur = finishTitleEdit;

      titleEl.onkeydown = (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          titleEl.blur();
        }
      };

      // DRAG HANDLE
      const dragHandle = document.createElement("div");
      dragHandle.className = "song-drag-handle";
      dragHandle.textContent = "⠿";
      dragHandle.draggable = true;

      dragHandle.addEventListener("dragstart", (e) => {
        e.stopPropagation();

        draggedSongIndex = i;
        pad.classList.add("dragging");

        if (e.dataTransfer) {
          e.dataTransfer.effectAllowed = "move";
        }
      });

      dragHandle.addEventListener("dragend", () => {
        pad.classList.remove("dragging");
      });

      pad.appendChild(dragHandle);

      // DELETE
      const deleteBtn = document.createElement("div");
      deleteBtn.className = "song-delete-btn";
      deleteBtn.textContent = "✕";

      deleteBtn.onclick = async (e) => {
        e.stopPropagation();

        const songToDelete = songs[i];
        if (!songToDelete) return;

        const tracks = songToDelete.tracks || [];

        for (const track of tracks) {
          const audioRef = track.mp3;

          if (isR2Audio(audioRef)) {
            const ok = await deleteR2Audio(audioRef);

            if (!ok) {
              await sampltonAlert({
                title: "Delete failed",
                text: "Song could not be deleted.",
                icon: "error"
              });
              return;
            }
          }
        }

        songs.splice(i, 1);

        await saveProject();

        renderSong();
      };

      pad.appendChild(deleteBtn);

      // DROP TARGET
      pad.addEventListener("dragover", (e) => {
        e.preventDefault();

        if (
          draggedSongIndex === null ||
          draggedSongIndex === i
        ) return;

        pad.classList.add("drag-over");
      });

      pad.addEventListener("dragleave", () => {
        pad.classList.remove("drag-over");
      });

      pad.addEventListener("drop", async (e) => {
        e.preventDefault();
        e.stopPropagation();

        pad.classList.remove("drag-over");

        if (
          draggedSongIndex === null ||
          draggedSongIndex === i
        ) return;

        const fromIndex = draggedSongIndex;
        const movedSong = songs.splice(fromIndex, 1)[0];

        let targetIndex = i;

        if (fromIndex < i) {
          targetIndex--;
        }

        songs.splice(targetIndex, 0, movedSong);

        draggedSongIndex = null;

        await saveProject();

        renderSong();
      });
    }

    // =========================
    // NORMAL MODE
    // =========================
    pad.onclick = async () => {

      if (songEditMode) return;

      pad.classList.add("loading");

      try {
        currentSongIndex = i;
        selectedSongIndex = i;
        viewMode = "song";

        const currentSong = songs[i];
       

        // Ak skladba ešte nemá žiadne audio,
        // otvor ju rovno v edit režime s + upload tlačidlom
        const hasAudio = currentSong.tracks.some(
          track => String(track.mp3 || "").trim() !== ""
        );
        
        if (!hasAudio) {
        
          // ak by nemala ani jeden track, vytvor základný
          if (!currentSong.tracks.length) {
            currentSong.tracks.push({
              song: currentSong.title,
              name: "New Loop",
              notes: "",
              mp3: "",
              bpm: 120,
              signature: 4,
              bars: 4,
              start_at: 0.01,
              fadeintime: 0.5,
              repeat: 1,
              autoplay: 1
            });
        
            await saveProject();
          }
        
          trackEditMode = true;
          trackSettingsMode = false;
        } else {
          trackEditMode = false;
        }
        
        await ensureAudioContext();

        if (!navigator.onLine) {
          pad.classList.remove("loading");
          renderSong();
          return;
        }  

        const showFirstLoadHint =
  !currentUser &&
  localStorage.getItem("guestFirstLoadHintSeen") !== "1";

if (showFirstLoadHint) {
  updateTrackSubtitle({
    notes:
      "First load saves audio in your browser. Next time it loads much faster and works offline. You can also preload all songs from Menu.",
    notesVisible: true
  });
}

        await cacheSongTracks(currentSong.tracks);
        await prepareSong(currentSong.tracks);

        if (showFirstLoadHint) {
          localStorage.setItem("guestFirstLoadHintSeen", "1");
        
          updateTrackSubtitle({
            notes: "Ready for fast & offline playback ✓",
            notesVisible: true
          });
        }

      } catch (err) {

        if (
          err.message === "NOT_CACHED" ||
          err.message === "OFFLINE"
        ) {
          pad.classList.remove("loading");
          return;
        }

        console.error("Audio load failed:", err);
        pad.classList.remove("loading");
      }

      pad.classList.remove("loading");
      renderSong();
    };

    grid.appendChild(pad);
    padsList.push(pad);

    index++;
  });

  // =========================
// ADD SONG PAD
// =========================
if (songEditMode) {
  const addPad = document.createElement("div");

  addPad.className = "pad add-song-pad";

  addPad.innerHTML = `
    <div class="pad-key">+</div>
    <div class="pad-title">ADD SONG</div>
    <div class="pad-info">new song</div>
  `;

  addPad.onclick = async (e) => {
    e.preventDefault();
    e.stopPropagation();

  
    if (!isPro && songs.length >= 1) {
      await sampltonAlert({
        title: "FREE limit",
        text: "FREE version allows only 1 song.",
        icon: "info"
      });
      return;
    }

    const newSong = {
      title: "New Song",
      tracks: []
    };

    // pridaj okamžite do RAM
    songs.push(newSong);

    selectedSongIndex = songs.length - 1;
    currentSongIndex = selectedSongIndex;

    // najprv prekresli, aby bolo hneď vidieť výsledok
    renderSong();

    try {
      await saveProject();
    //  console.log("✅ Song added:", newSong);
    } catch (err) {
      console.error("❌ Add song save failed:", err);
    }
  };

  grid.appendChild(addPad);
}

  // FREE → BUY PRO
  if (authReady && !isPro && !songEditMode) {
    const proPad = document.createElement("div");

    proPad.className = "pad buy-pro-pad";

    proPad.innerHTML = `
      <div class="pad-key">P</div>
      <div class="pad-title">BUY PRO for 10€</div>
      <div class="pad-info">Unlimited songs / 100 mb</div>
    `;

    proPad.onclick = async () => {

      if (!currentUser) {
        await sampltonAlert({
          title: "Sign in required",
          text: "Please sign in before buying PRO.",
          icon: "info"
        });
        return;
      }
    
      const confirm = await sampltonAlert({
        title: "Samplton PRO",
        icon: "info",
      
        html: `
          <div style="text-align:left; line-height:1.7;">
      
            <p style="
              font-size:24px;
              font-weight:bold;
              text-align:center;
            ">
              10 €
            </p>
      
            <p><b>Samplton PRO includes:</b></p>
      
            <p>
              ✓ Unlimited songs<br>
              ✓ 100 MB cloud storage<br>
              ✓ PRO features
            </p>
      
            <hr style="
              border:0;
              border-top:1px solid #333;
              margin:18px 0;
            ">
      
            ${legalCheckoutText()}
      
          </div>
        `,
      
        showCancelButton: true,
        confirmButtonText: "CONTINUE TO PAYMENT",
        cancelButtonText: "CANCEL",
      
        didOpen: () => {
          const termsLink =
            document.querySelector(".checkout-terms-link");
      
          const privacyLink =
            document.querySelector(".checkout-privacy-link");
      
          termsLink?.addEventListener("click", async (e) => {
            e.preventDefault();
            e.stopPropagation();
      
            Swal.close();
      
            await openLegalSection("terms", false);
      
            proPad.click();
          });
      
          privacyLink?.addEventListener("click", async (e) => {
            e.preventDefault();
            e.stopPropagation();
      
            Swal.close();
      
            await openLegalSection("privacy", false);
      
            proPad.click();
          });
        }
      });

      if (!confirm.isConfirmed) return;
    
      try {
        proPad.classList.add("loading");
    
        const token =
          await currentUser.getIdToken();
    
        const res = await fetch(
          `${R2_API}/create-checkout`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );
    
        const data = await res.json();
    
        if (!res.ok || !data.ok || !data.url) {
    
          console.error(
            "Checkout failed:",
            data
          );
    
          await sampltonAlert({
            title: "Checkout failed",
            text: "PRO checkout could not be started.",
            icon: "error"
          });
    
          return;
        }
    
        window.location.href = data.url;
    
      } catch (err) {
    
        console.error(
          "Checkout error:",
          err
        );
    
        await sampltonAlert({
          title: "Checkout failed",
          text: "PRO checkout could not be started.",
          icon: "error"
        });
    
      } finally {
    
        proPad.classList.remove("loading");
    
      }
    };
    grid.appendChild(proPad);
  }
}

function openNotesModal(text) {
  const modal = document.createElement("div");
  modal.className = "notes-modal";

  const box = document.createElement("div");
  box.className = "notes-box";

  box.innerHTML = `
    <div>${text}</div>
  `;

  modal.appendChild(box);
  document.body.appendChild(modal);

  modal.onclick = () => modal.remove();

  box.onclick = (e) => {
    e.stopPropagation();
  };
}

function getUrlParam(name) {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
}

function updateMetroCounter() {
  if (!metroCounterEl || !audioCtx || !source) {
    requestAnimationFrame(updateMetroCounter);
    return;
  }

  const beatDuration = 60 / tempo;
  const now = audioCtx.currentTime;
  const elapsed = now - currentStartAt;

  if (elapsed >= 0) {
    const totalBeats = Math.floor(elapsed / beatDuration);

    const beatsPerLoop = currentSignature * currentBars;
    const totalLoopBeats = beatsPerLoop * currentRepeat;

    const loopBeat = totalBeats % totalLoopBeats;

    const bar = Math.floor(loopBeat / currentSignature) + 1;
    const beat = (loopBeat % currentSignature) + 1;

    metroCounterEl.textContent = `${bar}l${beat}`;
  }

  requestAnimationFrame(updateMetroCounter);
}

function getNextBeatTime() {
  if (!audioCtx) return 0;

  const now = audioCtx.currentTime;
  const beatDuration = 60 / tempo;

  // 🔥 ak ešte nič nehrá → zarovnaj na najbližší beat OD TERAZ
  if (!source) {
    return Math.ceil(now / beatDuration) * beatDuration;
  }

  const elapsed = Math.max(0, now - currentStartAt);
  const beatsPassed = Math.floor(elapsed / beatDuration);

  return currentStartAt + (beatsPassed + 1) * beatDuration;
}

function updateActivePadBPM(bpm) {
  if (!activePadEl) return;
  const duration = 60 / bpm;
  activePadEl.style.animationDuration = duration + "s";
}

let loaderEl = null;


function getFileName(url) {
  if (!url) return "";
  let n = url.split("/").pop();
  n = n.replace(/\.[^/.]+$/, "");
  n = n.replace(/[-_]/g, " ");
  return n;
}

const R2_API = "https://samplton-api.matorybos.workers.dev";

function isR2Audio(value) {
  return String(value || "").startsWith("r2:");
}

function getR2FileName(value) {
  return String(value || "").slice(3);
}

function fixUrl(url) {
  if (!url) return "";

  const s = String(url).trim();

  if (!s) return "";

  // R2 reference nechaj tak
  if (s.startsWith("r2:")) return s;

  if (s.startsWith("http")) return s;

  return "https://www.divartwp.sk" + s;
}

function toNumber(val) {
  if (val == null) return 0;

  return parseFloat(
    String(val)
      .replace(/\s+/g, "")   // 🔥 odstráni všetky medzery
      .replace(",", ".")     // čiarka → bodka
  ) || 0;
}

// =======================
// TOP BAR
// =======================
function createTopBar() {
  const bar = document.createElement("div");
  bar.className = "top-bar";

  // 🔥 zobraz len v SONG view
  if (viewMode === "song") {

    const songNumber = document.createElement("div");
  songNumber.className = "song-number";
  songNumber.textContent = currentSongIndex + 1;



    const title = document.createElement("div");
    title.className = "song-title";
    title.textContent = songs[currentSongIndex]?.title || "";

    // klik = späť do menu (super UX)
    title.onclick = () => {
      viewMode = "menu";
      renderSong();
    };
    bar.appendChild(songNumber);
        bar.appendChild(title);
  }

  document.body.appendChild(bar);
}
// =======================
// BUILD PADS
// =======================
async function previewTrack(track, pad) {
  if (!track?.mp3) return;

  await ensureAudioContext();

  // offline → musí byť v cache
  if (!navigator.onLine) {
    const cached = await isTrackCached(track.mp3);
    if (!cached) return;
  }

  pad.classList.add("loading");

  try {
    const buffer = await loadAudio(track.mp3);

    const bpm = toNumber(track.bpm) || 120;
    const bars = toNumber(track.bars) || 1;
    const signature = toNumber(track.signature) || 4;
    const repeat = toNumber(track.repeat) || 1;
    const startAtOffset = toNumber(track.start_at);

    const duration =
      (60 / bpm) * signature * bars;

    // ak už niečo hrá → stop
    if (source) {
      try {
        source.stop();
      } catch (e) {}

      source = null;
    }

    if (schedulerTimer) {
      clearTimeout(schedulerTimer);
      schedulerTimer = null;
    }

    if (activePadEl) {
      activePadEl.classList.remove("active");
    }

    const startTime = audioCtx.currentTime + 0.03;

    const newSource = audioCtx.createBufferSource();
    newSource.buffer = buffer;

    const newGain = audioCtx.createGain();
    newGain.gain.value = 1;

    newSource.connect(newGain);
    newGain.connect(audioCtx.destination);

    newSource.loop = true;
    newSource.loopStart = startAtOffset;
    newSource.loopEnd = startAtOffset + duration;

    newSource.start(
      startTime,
      startAtOffset
    );

    source = newSource;
    currentGain = newGain;

    tempo = bpm;

    currentSignature = signature;
    currentBars = bars;

    currentStartAt = startTime;
    currentDuration = duration;

    currentRepeat = repeat;
    currentRepeatIndex = 0;

    nextNoteTime = startTime;
    lastSwitchTime = 0;

    activePadEl = pad;
    pad.classList.add("active");

    updateTrackSubtitle(track);

    if (schedulerTimer) {
      clearTimeout(schedulerTimer);
    }

    scheduler();

    if (!isMonitoring) {
      isMonitoring = true;
      monitorLoop();
    }

    updateActivePadBPM(bpm);
    updatePadCounters();

  } catch (err) {
    console.error("Preview failed:", err);
  }

  pad.classList.remove("loading");
}

function buildTrackSettingsPads(grid, track, trackIndex) {
  padsList = [];

  if (!track) return;

  // =========================
  // TRACK PAD
  // =========================

   const trackName =
    String(track.name || "").trim() ||
    getFileName(track.mp3) ||
    "New Loop";

  const trackPad = document.createElement("div");
  trackPad.className = "pad track-settings-main";
  trackPad.innerHTML = `
  <div class="pad-key">${trackIndex + 1}</div>
  <div class="pad-title">${trackName}</div>
  <div class="pad-info">PLAY PREVIEW</div>
`;
trackPad.onclick = async () => {
  await previewTrack(track, trackPad);
};

 

  trackPad.innerHTML = `
    <div class="pad-key">${trackIndex + 1}</div>
    <div class="pad-title">${trackName}</div>
    <div class="pad-info">TRACK SETTINGS</div>
  `;

  grid.appendChild(trackPad);
  // =========================
// STOP PAD
// =========================

const stopPad = document.createElement("div");
stopPad.className = "pad track-settings-stop";

stopPad.innerHTML = `
  <div class="pad-key playstop">■</div>
  <div class="pad-title">STOP</div>
  <div class="pad-info">stop preview</div>
`;

stopPad.onclick = (e) => {
  e.stopPropagation();

  if (source) {
    try { source.stop(); } catch (err) {}
    source = null;
  }

  if (schedulerTimer) {
    clearTimeout(schedulerTimer);
    schedulerTimer = null;
  }

  currentStartAt = 0;
  currentDuration = 0;
  nextNoteTime = 0;

  queuedTrack = null;

  if (activePadEl) {
    activePadEl.classList.remove("active");
  }

  if (queuedPadEl) {
    queuedPadEl.classList.remove("queued");
  }

  activePadEl = null;
  queuedPadEl = null;

  isMonitoring = false;

  trackPad.classList.remove("active");
};
grid.appendChild(stopPad);


  // =========================
  // HELPER - NUMBER PAD
  // =========================

  function createNumberSetting(label, field, fallback = 0) {
    const pad = document.createElement("div");
    pad.className = "pad setting-pad";
  
    const value =
      track[field] === "" ||
      track[field] == null
        ? fallback
        : track[field];
  
    pad.innerHTML = `
      <div class="setting-label">${label}</div>
  
      <input
      class="setting-number-input"
      type="number"
      inputmode="decimal"
      step="0.01"
      value="${value}"  
    >
    `;
  
    const input =
      pad.querySelector(".setting-number-input");
  
      const saveValue = () => {
        const num = toNumber(input.value);
      
        track[field] = num;
      
        if (field === "start_at" && num < 0) {
          track[field] = 0;
        }
      
        handleLiveUpdate(track);
        scheduleSave();
      };
  
    input.addEventListener("input", saveValue);
  
    input.addEventListener("click", (e) => {
      e.stopPropagation();
      input.select();
    });
  
    grid.appendChild(pad);
  }

  // =========================
  // SETTINGS
  // =========================

  createNumberSetting("BPM", "bpm", 120);

  createNumberSetting("BARS", "bars", 4);

  createNumberSetting("REPEAT", "repeat", 1);

  createNumberSetting("SIGNATURE", "signature", 4);

  createNumberSetting("START", "start_at", 0.01);

  createNumberSetting("FADE", "fadeintime", 0);


  // =========================
  // AUTOPLAY
  // =========================

  const autoplayPad = document.createElement("div");
  autoplayPad.className = "pad setting-pad autoplay-setting-pad";

  const autoplayOn =
    track.autoplay === "" ||
    track.autoplay == null
      ? true
      : toNumber(track.autoplay) !== 0;

  function updateAutoplayPad() {
    const on =
      track.autoplay === "" ||
      track.autoplay == null
        ? true
        : toNumber(track.autoplay) !== 0;

    autoplayPad.innerHTML = `
      <div class="setting-label">AUTOPLAY</div>
      <div class="setting-value">${on ? "ON" : "OFF"}</div>
      <div class="pad-info">tap to switch</div>
    `;
  }

  autoplayPad.onclick = async () => {
    const current =
      track.autoplay === "" ||
      track.autoplay == null
        ? 1
        : toNumber(track.autoplay);

    track.autoplay = current === 0 ? 1 : 0;

    updateAutoplayPad();

    handleLiveUpdate(track);
    await saveProject();
  };

  updateAutoplayPad();

  grid.appendChild(autoplayPad);


  // =========================
  // NOTES
  // =========================

  const notesPad = document.createElement("div");
  notesPad.className = "pad setting-pad notes-setting-pad";

  notesPad.innerHTML = `
  <div class="setting-label">NOTES</div>

  <div
    class="setting-notes"
    contenteditable="true"
  ></div>

  <label class="notes-visible-option">
    <input
      type="checkbox"
      class="notes-visible-checkbox"
      ${track.notesVisible === true ? "checked" : ""}
    >
    subtitle
  </label>
`;

  const notesEl = notesPad.querySelector(".setting-notes");
  const notesCheckbox =
  notesPad.querySelector(".notes-visible-checkbox");
  notesCheckbox.onclick = (e) => {
    e.stopPropagation();
  };
  
  notesCheckbox.onchange = async () => {
    track.notesVisible = notesCheckbox.checked;
  
    updateTrackSubtitle(
      track === getCurrentActiveTrack()
        ? track
        : null
    );
  
    await saveProject();
  };
  notesEl.textContent = track.notes || "";

  notesEl.onclick = (e) => {
    e.stopPropagation();
    notesEl.focus();
  };

  notesEl.oninput = () => {
    track.notes = notesEl.textContent;
    scheduleSave();
  };

  grid.appendChild(notesPad);


  // =========================
  // BACK
  // =========================

  const backPad = document.createElement("div");
  backPad.className = "pad back-pad";

  backPad.innerHTML = `
  <div class="pad-key playstop">◀◀</div>
    <div class="pad-title">BACK</div>
    <div class="pad-info">track editor</div>
  `;

  backPad.onclick = () => {
    trackSettingsMode = false;
    trackSettingsIndex = null;

    trackEditMode = true;

    renderSong();
  };

  grid.appendChild(backPad);
}

async function buildSampleLibraryPads(grid) {
  padsList = [];

  if (!currentUser) {
    const infoPad = document.createElement("div");
    infoPad.className = "pad";
  
    infoPad.innerHTML = `
      <div>👤</div>
      <div class="pad-title">NO LIBRARY</div>
      <div class="pad-info">click to sign in</div>
    `;
  
    infoPad.onclick = async () => {
      const isMobile =
        /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  
      try {
        if (isMobile) {
          await signInWithRedirect(auth, provider);
        } else {
          await signInWithPopup(auth, provider);
        }
      } catch (error) {
        console.error("Google login error:", error);
  
        await sampltonAlert({
          title: "Sign in failed",
          text: error.message,
          icon: "error"
        });
      }
    };
  
    grid.appendChild(infoPad);
  
    // BACK
    const backPad = document.createElement("div");
    backPad.className = "pad back-pad";
  
    backPad.innerHTML = `
      <div class="pad-key playstop">◀◀</div>
      <div class="pad-title">BACK</div>
      <div class="pad-info">track editor</div>
    `;
  
    backPad.onclick = () => {
      sampleLibraryMode = false;
      sampleLibraryTargetTrackIndex = null;
  
      trackEditMode = true;
      trackSettingsMode = false;
  
      renderSong();
    };
  
    grid.appendChild(backPad);
  
    return;
  }

  const loadingPad = document.createElement("div");
  loadingPad.className = "pad";

  loadingPad.innerHTML = `
    <div class="pad-title">LOADING...</div>
    <div class="pad-info">Sample Library</div>
  `;

  grid.appendChild(loadingPad);

  try {
    const token = await currentUser.getIdToken();

    const res = await fetch(
      `${R2_API}/files`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    const data = await res.json();

    loadingPad.remove();

    if (!res.ok || !data.ok) {
      throw new Error(data.error || "FILES_LOAD_FAILED");
    }

    const files = data.files || [];

    if (!files.length) {
      const emptyPad = document.createElement("div");
      emptyPad.className = "pad";

      emptyPad.innerHTML = `
        <div class="pad-title">EMPTY LIBRARY</div>
        <div class="pad-info">No audio files</div>
      `;

      grid.appendChild(emptyPad);
    }

    files.forEach((file, index) => {
      const pad = document.createElement("div");
      pad.className = "pad sample-file-pad";

      const sizeMB =
        Number(file.size || 0) / 1024 / 1024;

      const displayName =
        String(file.name || file.file || "Audio")
          .replace(/\.[^/.]+$/, "");

          pad.innerHTML = `
          ${
            sampleLibraryTargetTrackIndex !== null
              ? `<div class="sample-load-btn">LOAD</div>`
              : `<div class="sample-delete-btn">✕</div>`
          }
        
         
          <div class="pad-title"></div>
          <div class="pad-info">${sizeMB.toFixed(1)} MB</div>
        
          <div class="sample-pause-btn">⏸</div>
        `;

      pad.querySelector(".pad-title").textContent =
        displayName;

      const audioRef =
        file.ref || `r2:${file.file}`;

      // =========================
      // LOAD INTO TRACK
      // =========================

      const loadBtn =
        pad.querySelector(".sample-load-btn");

      if (loadBtn) {
        loadBtn.onclick = async (e) => {
          e.stopPropagation();

          const song = songs[currentSongIndex];
          if (!song) return;

          const track =
            song.tracks[sampleLibraryTargetTrackIndex];

          if (!track) return;

          track.mp3 = audioRef;
          track.fileName =
            file.name || file.file || "";
          track.fileSize =
            Number(file.size || 0);

          if (
            !String(track.name || "").trim() ||
            track.name === "New Loop"
          ) {
            track.name = displayName;
          }

          await saveProject();

          // priprav sample aj lokálne
          await cacheSongTracks([
            {
              mp3: audioRef
            }
          ]);

          await prepareSong([
            {
              mp3: audioRef
            }
          ]);

          stopSampleLibraryPreview();

          sampleLibraryMode = false;
          sampleLibraryTargetTrackIndex = null;

          trackEditMode = true;

          renderSong();
        };
      }

      const deleteBtn =
  pad.querySelector(".sample-delete-btn");

if (deleteBtn) {
  deleteBtn.onclick = async (e) => {
    e.stopPropagation();

    const usedBy = [];

    songs.forEach((song, songIndex) => {
      (song.tracks || []).forEach((track, trackIndex) => {
        if (track.mp3 === audioRef) {
          usedBy.push({
            songIndex,
            trackIndex,
            songTitle: song.title,
            trackName: track.name
          });
        }
      });
    });

    let message =
      `Delete "${displayName}" from Sample Library?`;

    if (usedBy.length > 0) {
      message =
        `"${displayName}" is used by ${usedBy.length} track(s).\n\n` +
        `Deleting it will make those tracks lose their audio.\n\n` +
        `Delete anyway?`;
    }

    const result = await sampltonAlert({
      title: "Delete sample?",
      text: message,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "DELETE",
      cancelButtonText: "CANCEL"
    });
    
    if (!result.isConfirmed) return;

    stopSampleLibraryPreview();

    const ok = await deleteR2Audio(audioRef);

    if (!ok) {
      await sampltonAlert({
        title: "Delete failed",
        text: "Sample could not be deleted.",
        icon: "error"
      });
      return;
    }

    renderSong();
  };
}

      // =========================
      // PAD CLICK = PLAY / RESTART
      // =========================

      pad.onclick = async () => {
        try {
          await ensureAudioContext();

          pad.classList.add("loading");

          const existing =
            await loadFromDB(audioRef);

          if (!existing) {
            await cacheSongTracks([
              {
                mp3: audioRef
              }
            ]);
          }

          const buffer =
            await loadAudio(audioRef);

          stopSampleLibraryPreview();

          samplePreviewBuffer = buffer;
          samplePreviewPad = pad;
          samplePreviewOffset = 0;
          samplePreviewPaused = false;

          const previewSource =
            audioCtx.createBufferSource();

          previewSource.buffer = buffer;
          previewSource.loop = false;

          const gain =
            audioCtx.createGain();

          gain.gain.value = 1;

          previewSource.connect(gain);
          gain.connect(audioCtx.destination);

          samplePreviewStartedAt =
            audioCtx.currentTime;

          previewSource.start(
            0,
            samplePreviewOffset
          );

          samplePreviewSource =
            previewSource;

          pad.classList.add("active");

          previewSource.onended = () => {
            if (
              samplePreviewSource === previewSource &&
              !samplePreviewPaused
            ) {
              samplePreviewSource = null;
              samplePreviewBuffer = null;
              samplePreviewOffset = 0;

              pad.classList.remove("active");

              if (samplePreviewPad === pad) {
                samplePreviewPad = null;
              }
            }
          };

        } catch (err) {
          console.error(
            "Sample preview failed:",
            err
          );

          sampltonAlert({
            title: "Audio preview failed",
            icon: "error"
          });

        } finally {
          pad.classList.remove("loading");
        }
      };

      // =========================
      // PAUSE / RESUME
      // =========================

      const pauseBtn =
        pad.querySelector(".sample-pause-btn");

      pauseBtn.onclick = async (e) => {
        e.stopPropagation();

        await ensureAudioContext();

        // iný sample ešte nehrá
        if (
          samplePreviewPad !== pad ||
          !samplePreviewBuffer
        ) {
          pad.click();
          return;
        }

        // PAUSE
        if (
          samplePreviewSource &&
          !samplePreviewPaused
        ) {
          const elapsed =
            audioCtx.currentTime -
            samplePreviewStartedAt;

          samplePreviewOffset += elapsed;

          if (
            samplePreviewOffset >=
            samplePreviewBuffer.duration
          ) {
            samplePreviewOffset = 0;
          }

          samplePreviewPaused = true;

          try {
            samplePreviewSource.stop();
          } catch (err) {}

          samplePreviewSource = null;

          pauseBtn.textContent = "▶";
          pad.classList.remove("active");

          return;
        }

        // RESUME
        if (
          samplePreviewPaused &&
          samplePreviewBuffer
        ) {
          const previewSource =
            audioCtx.createBufferSource();

          previewSource.buffer =
            samplePreviewBuffer;

          previewSource.loop = false;

          const gain =
            audioCtx.createGain();

          gain.gain.value = 1;

          previewSource.connect(gain);
          gain.connect(audioCtx.destination);

          samplePreviewStartedAt =
            audioCtx.currentTime;

          previewSource.start(
            0,
            samplePreviewOffset
          );

          samplePreviewSource =
            previewSource;

          samplePreviewPaused = false;

          pauseBtn.textContent = "⏸";
          pad.classList.add("active");

          previewSource.onended = () => {
            if (
              samplePreviewSource === previewSource &&
              !samplePreviewPaused
            ) {
              samplePreviewSource = null;
              samplePreviewBuffer = null;
              samplePreviewOffset = 0;
              samplePreviewPad = null;

              pad.classList.remove("active");
              pauseBtn.textContent = "⏸";
            }
          };
        }
      };

      grid.appendChild(pad);
      padsList.push(pad);
    });

  } catch (err) {
    loadingPad.remove();

    console.error(
      "Sample Library load failed:",
      err
    );

    const errorPad =
      document.createElement("div");

    errorPad.className = "pad";

    errorPad.innerHTML = `
      <div class="pad-title">LOAD ERROR</div>
      <div class="pad-info">Sample Library</div>
    `;

    grid.appendChild(errorPad);
  }

  // =========================
  // BACK
  // =========================

  const backPad =
    document.createElement("div");

  backPad.className = "pad back-pad";

  backPad.innerHTML = `
  <div class="pad-key playstop">◀◀</div>
    <div class="pad-title">BACK</div>
    <div class="pad-info">track editor</div>
  `;

  backPad.onclick = () => {
    stopSampleLibraryPreview();

    sampleLibraryMode = false;
    sampleLibraryTargetTrackIndex = null;

    renderSong();
  };

  grid.appendChild(backPad);
}

function stopSampleLibraryPreview() {
  if (samplePreviewSource) {
    try {
      samplePreviewSource.stop();
    } catch (e) {}
  }

  if (samplePreviewPad) {
    samplePreviewPad.classList.remove("active");

    const pauseBtn =
      samplePreviewPad.querySelector(".sample-pause-btn");

    if (pauseBtn) {
      pauseBtn.textContent = "⏸";
    }
  }

  samplePreviewSource = null;
  samplePreviewBuffer = null;
  samplePreviewStartedAt = 0;
  samplePreviewOffset = 0;
  samplePreviewPaused = false;
  samplePreviewPad = null;
}


function buildTrackEditPads(grid, tracks) {
  padsList = [];

  tracks.forEach((track, i) => {
    const pad = document.createElement("div");
    pad.className = "pad track-edit-pad";

   pad.innerHTML = `
  <div class="pad-key">${i + 1}</div>

  <div class="pad-title track-edit-title"></div>

  <div
    class="track-upload-btn"
    title="${track.mp3 ? "Change audio" : "Upload audio"}"
  >
    ${track.mp3 ? "↻" : "+"}
  </div>
`;

    const titleEl = pad.querySelector(".track-edit-title");
    titleEl.textContent =
      String(track.name || "").trim() ||
      getFileName(track.mp3) ||
      "New Loop";

    // =========================
    // EDIT NAME
    // =========================

    titleEl.onclick = (e) => {
      e.stopPropagation();

      titleEl.contentEditable = "true";
      titleEl.focus();

      const range = document.createRange();
      range.selectNodeContents(titleEl);

      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    };

    const finishNameEdit = async () => {
      let val = titleEl.textContent.trim();

      if (!val || isOnlyNumber(val)) {
        val = "New Loop";
      }

      track.name = val;
      titleEl.textContent = val;
      titleEl.contentEditable = "false";

      await saveProject();
    };

    titleEl.onblur = finishNameEdit;

    titleEl.onkeydown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        titleEl.blur();
      }
    };

    // =========================
    // DRAG
    // =========================

    const dragHandle = document.createElement("div");
    dragHandle.className = "track-drag-handle";
    dragHandle.textContent = "⠿";
    dragHandle.draggable = true;

    dragHandle.addEventListener("dragstart", (e) => {
      e.stopPropagation();

      draggedTrackIndex = i;
      pad.classList.add("dragging");

      if (e.dataTransfer) {
        e.dataTransfer.effectAllowed = "move";
      }
    });

    dragHandle.addEventListener("dragend", () => {
      pad.classList.remove("dragging");
      draggedTrackIndex = null;
    });

    pad.appendChild(dragHandle);

    // =========================
    // DELETE
    // =========================

    const deleteBtn = document.createElement("div");
    deleteBtn.className = "track-delete-btn";
    deleteBtn.textContent = "✕";

    deleteBtn.onclick = async (e) => {
      e.stopPropagation();
    
      const result = await sampltonAlert({
        title: "Delete track?",
        text: `Delete "${track.name || "Track"}"?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "CANCEL"
      });
      
      if (!result.isConfirmed) return;
    
      const song = songs[currentSongIndex];
      if (!song) return;
    
      song.tracks.splice(i, 1);
    
      await saveProject();
    
      renderSong();
    };

    pad.appendChild(deleteBtn);

    // =========================
    // UPLOAD / CHANGE
    // =========================

    const uploadBtn = pad.querySelector(".track-upload-btn");

    uploadBtn.onclick = async (e) => {
      e.stopPropagation();
    
      if (!currentUser) {
        await sampltonAlert({
          title: "Sign in required",
          text: "To upload audio files, please sign in with Google from the menu.",
          icon: "info"
        });
    
        return;
      }
    
      const input = document.createElement("input");

      input.type = "file";
      input.accept = "audio/*,.wav,.mp3,.flac,.ogg";
      
      input.onchange = async () => {
        const file = input.files?.[0];
        if (!file) return;
      
        const uploading = document.createElement("div");
        uploading.className = "uploading";
        uploading.textContent = "UPLOADING...";
      
        document.body.appendChild(uploading);
      
        try {
          const ok = await uploadTrackToR2(track, file);
      
          if (ok) {
            uploadBtn.textContent = "↻";
      
            titleEl.textContent =
              String(track.name || "").trim() ||
              getFileName(track.mp3) ||
              "New Loop";
      
            await saveProject();
      
          } else {
            uploadBtn.textContent =
              track.mp3 ? "↻" : "+";
          }
      
        } catch (err) {
          console.error("Track upload failed:", err);
      
          uploadBtn.textContent =
            track.mp3 ? "↻" : "+";
      
        } finally {
          uploading.remove();
        }
      };
      
      input.click();
    };
// =========================
// LOAD FROM SAMPLE LIBRARY
// =========================

const libraryBtn = document.createElement("div");
libraryBtn.className = "track-library-btn";
libraryBtn.textContent = "▣";
libraryBtn.title = "Load from Sample Library";

libraryBtn.onclick = (e) => {
  e.stopPropagation();

  sampleLibraryTargetTrackIndex = i;
  sampleLibraryMode = true;

  renderSong();
};

pad.appendChild(libraryBtn);

    // =========================
    // PENCIL
    // =========================

    const editBtn = document.createElement("div");
    editBtn.className = "track-settings-btn";
    editBtn.textContent = "✎";

    editBtn.onclick = (e) => {  
      e.stopPropagation();
    
      trackSettingsIndex = i;
      trackSettingsMode = true;
    
      renderSong();
    };
    pad.appendChild(editBtn);

    // =========================
    // DRAG TARGET
    // =========================

    pad.addEventListener("dragover", (e) => {
      e.preventDefault();

      if (
        draggedTrackIndex === null ||
        draggedTrackIndex === i
      ) return;

      pad.classList.add("drag-over");
    });

    pad.addEventListener("dragleave", () => {
      pad.classList.remove("drag-over");
    });

    pad.addEventListener("drop", async (e) => {
      e.preventDefault();
      e.stopPropagation();

      pad.classList.remove("drag-over");

      if (
        draggedTrackIndex === null ||
        draggedTrackIndex === i
      ) return;

      const fromIndex = draggedTrackIndex;
      const movedTrack = tracks.splice(fromIndex, 1)[0];

      let targetIndex = i;

      if (fromIndex < i) {
        targetIndex--;
      }

      tracks.splice(targetIndex, 0, movedTrack);

      draggedTrackIndex = null;

      await saveProject();
      renderSong();
    });

    grid.appendChild(pad);
    padsList.push(pad);
  });


  // =========================
  // ADD TRACK
  // =========================

  const addPad = document.createElement("div");
  addPad.className = "pad add-track-pad";

  addPad.innerHTML = `
    <div class="pad-key">+</div>
    <div class="pad-title">ADD TRACK</div>
    <div class="pad-info">new sample</div>
  `;

  addPad.onclick = async () => {
    const song = songs[currentSongIndex];
    if (!song) return;

    const lastTrack = song.tracks[song.tracks.length - 1];

    const newTrack = {
      song: song.title,
      name: "New Loop",
      notes: "",
      mp3: "",
      bpm: lastTrack ? toNumber(lastTrack.bpm) || 120 : 120,
      signature: 4,
      bars: 4,
      start_at: 0.01,
      fadeintime: 0.5,
      repeat: 1,
      autoplay: 1
    };

    song.tracks.push(newTrack);

    await saveProject();
    renderSong();
  };

  grid.appendChild(addPad);

  // =========================
// SAMPLE LIBRARY
// =========================

const libraryPad = document.createElement("div");
libraryPad.className = "pad sample-library-pad";

libraryPad.innerHTML = `
  <div class="pad-key">+</div>
  <div class="pad-title">SAMPLE LIBRARY</div>
  <div class="pad-info">R2 audio files</div>
`;

libraryPad.onclick = () => {
  sampleLibraryTargetTrackIndex = null;
  sampleLibraryMode = true;
  renderSong();
};

grid.appendChild(libraryPad);

  // =========================
// DUPLICATE LAST
// =========================

const duplicatePad = document.createElement("div");
duplicatePad.className = "pad duplicate-track-pad";

duplicatePad.innerHTML = `
  <div class="pad-key">⧉</div>
  <div class="pad-title">DUPLICATE LAST</div>
  <div class="pad-info">copy last track</div>
`;

duplicatePad.onclick = async () => {
  const song = songs[currentSongIndex];
  if (!song) return;

  if (!song.tracks.length) {
    return;
  }

  const lastTrack = song.tracks[song.tracks.length - 1];

  const duplicatedTrack = {
    ...lastTrack,

    // nech má nový názov
    name: `${lastTrack.name || "New Loop"} COPY`
  };

  song.tracks.push(duplicatedTrack);

  await saveProject();

  renderSong();
};

grid.appendChild(duplicatePad);

}




function buildPads(grid, tracks) {
  const defaultBpm = toNumber(tracks.find((t) => t.bpm)?.bpm) || 120;
  
  padsList = [];
  // METRONOME PAD
  const metroPad = document.createElement("div");
  metroPad.className = "pad metronome-pad";


  function updateMetroPad() {
    updateMetroPadFn = updateMetroPad;
  
    metroPad.innerHTML = `
      <div class="pad-title"></div>
      <div class="pad-info">${metronomeMuted ? "OFF" : "ON"}</div>
      <div class="pad-counter"></div>
      <input type="range" min="0" max="1" step="0.01" value="${metronomeVolume}" class="metro-volume">
    `;
    
  
    metroCounterEl = metroPad.querySelector(".pad-counter");
  }

  metroPad.addEventListener("input", (e) => {
    if (e.target.classList.contains("metro-volume")) {
      metronomeVolume = parseFloat(e.target.value);
      localStorage.setItem("metroVol", String(metronomeVolume));
    }
  });

  metroPad.onclick = (e) => {
    if (e.target.classList.contains("metro-volume")) return;

    metronomeMuted = !metronomeMuted;
    localStorage.setItem("metroMuted", metronomeMuted ? "1" : "0");
    updateMetroPad();
  };

  updateMetroPad();

seqPad = document.createElement("div");
seqPad.className = "pad seq-pad";


seqPad.onclick = toggleSequence;


function getManualQuantizedTime() {
  if (!audioCtx) return 0;

  const now = audioCtx.currentTime;

  // 🔥 NONE = okamžite
  if (quantizeMode === "NONE") {
    return now;
  }

  if (!source) return now;

  const beatDuration = 60 / tempo;
  const elapsed = now - currentStartAt;
  const beatsPassed = Math.floor(elapsed / beatDuration);

  if (quantizeMode === "BEAT") {
    return currentStartAt + (beatsPassed + 1) * beatDuration;
  }

  if (quantizeMode === "FOUR_BEATS") {
    const step = 4;
    const stepsPassed = Math.floor(beatsPassed / step);

    return currentStartAt +
      (stepsPassed + 1) * step * beatDuration;
  }

  if (quantizeMode === "BAR") {
    const loopsPassed =
      Math.floor(elapsed / currentDuration);

    return currentStartAt +
      (loopsPassed + 1) * currentDuration;
  }

  return now;
}

let quantPad = document.createElement("div");
quantPad.className = "pad";

function updateQuantPad() {

  let label = quantizeMode;
   if (quantizeMode === "FOUR_BEATS") label = "4 BEAT";
  if (quantizeMode === "BEAT") label = "1 BEAT";
  if (quantizeMode === "BAR") label = "BAR";

  quantPad.innerHTML = `
    <div class="pad-key">Q</div>
    <div class="pad-title">QUANT</div>
    <div class="pad-info">${label}</div>
  `;
}

updateQuantPadFn = updateQuantPad;

quantPad.onclick = () => {
  if (quantizeMode === "BAR") {
    quantizeMode = "FOUR_BEATS";
  } else if (quantizeMode === "FOUR_BEATS") {
    quantizeMode = "BEAT";
  } else if (quantizeMode === "BEAT") {
    quantizeMode = "NONE";
  } else {
    quantizeMode = "BAR";
  }

  updateQuantPad();
};
updateQuantPad();



  // 🔴 STOP PAD
  const stopPad = document.createElement("div");
  stopPad.className = "pad stop-pad";

  stopPad.innerHTML = `
  <div class="pad-key playstop" style="font-size:30px!important;top:5px!important">■</div>
    <div class="pad-title">STOP</div>
    <div class="pad-info">panic</div>
  `;

  stopPad.onclick = () => {

    if (source) {
      try { source.stop(); } catch(e) {}
      source = null;
    }

    if (schedulerTimer) {
      clearTimeout(schedulerTimer);
      schedulerTimer = null;
    }

    currentStartAt = 0;
    currentDuration = 0;
    nextNoteTime = 0;

    queuedTrack = null;

    if (activePadEl) activePadEl.classList.remove("active");
    if (queuedPadEl) queuedPadEl.classList.remove("queued");

    activePadEl = null;
    queuedPadEl = null;

    isMonitoring = false;
  };

  const backPad = document.createElement("div");
backPad.className = "pad back-pad";

backPad.innerHTML = `
  <div class="pad-key playstop">◀◀</div>
  <div class="pad-title">Back</div>
  <div class="pad-info">menu</div>
`;

backPad.onclick = () => { 
  selectedTrackIndex = selectedPadIndex;
  selectedSongIndex = currentSongIndex;
  viewMode = "menu";
  renderSong();
};


  let trackIndex = 1;

  // TRACKS
  tracks.forEach((track) => {
    if (!track.mp3) return;

    const bpm = toNumber(track.bpm) || defaultBpm;
    const baseBars = toNumber(track.bars) || 8;
const repeat = toNumber(track.repeat) || 1;
const bars = baseBars;
const totalBars = baseBars * repeat;
        const signature = toNumber(track.signature) || 4;
    const startAtOffset = toNumber(track.start_at);

    const trackName =
      track.name && track.name.trim() !== ""
        ? track.name
        : getFileName(track.mp3);

    const pad = document.createElement("div");
    pad.className = "pad";

    pad.innerHTML = `
    <div class="pad-key">${trackIndex}</div>
      <div class="pad-title">${trackName}</div>
      <div class="pad-info">${bpm} | ${baseBars} | ${repeat}x | ${signature}/4</div>
     
          `;

          // 🔥 NOTES (SEM!)
    if (String(track.notes || "").trim() !== "") {
    const note = document.createElement("div");
    note.className = "pad-note";
    note.innerHTML = "✎";

    note.onclick = (e) => {
      e.stopPropagation();
      openNotesModal(track.notes);
    };

    pad.appendChild(note);
  }

    trackIndex++;

    pad.onclick = async () => {



      if (!track.mp3) return;

       // 🔥 OFFLINE CHECK
  if (!navigator.onLine) {
    const cached = await isTrackCached(track.mp3);

    if (!cached) {
      return; // nič nerob → žiadny error
    }
  }

    //  console.log("START OFFSET:", startAtOffset);

      pad.classList.add("loading");

      try {
        const buffer = await loadAudio(track.mp3);

        // restart active pad na najbližší beat
        if (pad === activePadEl && source && audioCtx) {

        
          const restartTime =
          quantizeMode === "NONE"
            ? audioCtx.currentTime
            : getNextBeatTime();

          const newSource = audioCtx.createBufferSource();
          newSource.buffer = buffer;

          const baseDuration = (60 / bpm) * signature * bars;
          
          const loopStart = startAtOffset;

          if (quantizeMode === "NONE") {
            newSource.loop = false;
          } else {
            newSource.loop = true;
            newSource.loopStart = loopStart;
            newSource.loopEnd = loopStart + baseDuration;
          }

          const newGain = audioCtx.createGain();
          newGain.gain.value = 1;

          newSource.connect(newGain);
          newGain.connect(audioCtx.destination);

          newSource.start(restartTime, loopStart);
          source.stop(restartTime);

          source = newSource;
          currentGain = newGain;
          currentStartAt = restartTime;
currentDuration = baseDuration;
currentRepeat = repeat;
currentRepeatIndex = 0;

          pad.classList.remove("loading");

          return;
        }

      
          if (pad === queuedPadEl) {
            if (queuedTrack) {
              queuedTrack.switchTime = getManualQuantizedTime();
          } else {
            // 🔥 už sa preplo → znovu queue
            const index = padsList.indexOf(pad);
            queuePadByIndex(index);
          }
        
          pad.classList.remove("loading");
          return;
        }

        if (!source) {

          
          await startFirstTrack(track.mp3, bpm, bars, signature, startAtOffset, repeat);

          pad.classList.remove("loading");

          if (activePadEl) activePadEl.classList.remove("active");
          activePadEl = pad;
          pad.classList.add("active");

          updateTrackSubtitle(track);
          
          return;
        }

        

        if (queuedPadEl) queuedPadEl.classList.remove("queued");
        queuedPadEl = pad;
        pad.classList.add("queued");

        queuedTrack = {
          buffer,
          bpm,
          bars,
          signature,
          startAtOffset,
          fadeTime: toNumber(track.fadeintime) || 0,
          fadeTime: track.fadeintime,
          switchTime: getManualQuantizedTime(),
                    repeat,
repeatIndex: 0
        };

        setTimeout(() => {
          pad.classList.remove("loading");
          
        }, 200);
      } catch (err) {
        console.error("Audio load failed:", err);
        pad.classList.remove("loading");
      }
    };

     // 🔥 CHECK CACHE (tu to patrí)
     isTrackCached(track.mp3).then((cached) => {

      if (!navigator.onLine) {
        // 🔥 offline → nič nezobrazuj
        return;
      }
    
      if (!cached) {
        pad.classList.add("not-loaded");
    
        const badge = document.createElement("div");
        badge.className = "pad-missing";
        badge.textContent = "!";
        pad.appendChild(badge);
      }
    });

    grid.appendChild(pad);
    padsList.push(pad);
  });
  grid.appendChild(metroPad);
  grid.appendChild(quantPad);
  grid.appendChild(seqPad);
  grid.appendChild(stopPad);
  grid.appendChild(backPad);

  updateSeqPad();
  selectedPadIndex = selectedTrackIndex;
  updatePadSelection();
}


// =======================
// INIT / RENDER
// =======================

let pendingFileData = null;

function scheduleSave() {
  clearTimeout(saveTimeout);

  saveTimeout = setTimeout(() => {
    saveProject();
  }, 300); // delay
}

async function init() {
  try {
   
    await loadTracks();

    const songParam = getUrlParam("song");

    if (songParam) {
      viewMode = "song"; // 🔥 len ak je param

      if (!isNaN(songParam)) {
        const index = parseInt(songParam);
        if (songs[index]) currentSongIndex = index;
      } else {
        const index = songs.findIndex(
          s => s.title.toLowerCase() === songParam.toLowerCase()
        );
        if (index !== -1) currentSongIndex = index;
      }
    } else {
      viewMode = "menu"; // 🔥 default
    }

    renderSong();
    updateMetroCounter();

  } catch (err) {
    console.error("Init failed:", err);
    document.body.innerHTML = `<div style="color:white;padding:20px;">Load error</div>`;
  }
}

function resetApp(clearUi = true) {
  if (source) {
    try {
      source.stop();
    } catch (e) {}
    source = null;
  }

  if (schedulerTimer) {
    clearTimeout(schedulerTimer);
    schedulerTimer = null;
  }

  queuedTrack = null;
  isMonitoring = false;
  activePadEl = null;
  queuedPadEl = null;
  currentGain = null;
  currentStartAt = 0;
  currentDuration = 0;

  if (clearUi) {
    document.body.innerHTML = "";
  } else {
    const oldLoader = loaderEl;
    document.body.innerHTML = "";
    if (oldLoader) {
      loaderEl = oldLoader;
      document.body.appendChild(loaderEl);
    }
  }
}

// =======================
// START
// =======================

document.addEventListener("click", (e) => {

  // klik v SweetAlert → menu nechaj otvorené
  if (e.target.closest(".swal2-container")) {
    return;
  }

  // klik mimo menu → zavri menu
  if (!e.target.closest(".top-bar-wrapper")) {
    document
      .querySelector(".top-menu-panel")
      ?.classList.add("hidden");
  }
});

document.addEventListener("keydown", (e) => {

  if (e.key === "Backspace") {

    // 🔥 ak píšeš do inputu → nechaj browser
    if (
      e.target.tagName === "INPUT" ||
      e.target.tagName === "TEXTAREA" ||
      e.target.isContentEditable
    ) return;
  
    // 🔥 ak si v song view → späť do menu
    if (e.key === "Backspace" && viewMode === "song") {
      e.preventDefault();

      selectedTrackIndex = selectedPadIndex; 
      selectedSongIndex = currentSongIndex;  
    
      viewMode = "menu";
      renderSong();
    }
  }

  if (e.key === "Escape" && sheetEditorEl) {
    sheetEditorEl.style.display = "none";
  }

  if (
    e.target.tagName === "INPUT" ||
    e.target.isContentEditable
  ) return;

  if (e.key.toLowerCase() === "q") {

    if (quantizeMode === "BAR") {
      quantizeMode = "FOUR_BEATS";
    } else if (quantizeMode === "FOUR_BEATS") {
      quantizeMode = "BEAT";
    } else if (quantizeMode === "BEAT") {
      quantizeMode = "NONE";
    } else {
      quantizeMode = "BAR";
    }
  
    updateQuantPadFn?.();
  }

  if (e.key.toLowerCase() === "r") {

    const prevSongIndex = currentSongIndex; // 🔥 zapamätaj
  
    resetApp(false); 
  
    loadTracks().then((tracks) => {
      songs = groupTracksBySong(tracks);
  
      // 🔥 vráť sa na rovnakú skladbu
      if (songs[prevSongIndex]) {
        currentSongIndex = prevSongIndex;
      } else {
        currentSongIndex = 0;
      }
  
      viewMode = "song"; // 🔥 nikdy menu
      renderSong();
    });
  }    const key = e.key;

// čísla 1–9
if (/^[1-9]$/.test(key)) {
  const index = parseInt(key) - 1;
  const pad = padsList[index];
  if (pad) pad.click();
}

// nula = 10. pad
if (key === "0") {
  const pad = padsList[9];
  if (pad) pad.click();
}

    if (e.key.toLowerCase() === "s") {

      if (source) {
        try { source.stop(); } catch(e) {}
        source = null;
      }
    
      if (schedulerTimer) {
        clearTimeout(schedulerTimer);
        schedulerTimer = null;
      }
    
      currentStartAt = 0;
      currentDuration = 0;
      nextNoteTime = 0;
    
      queuedTrack = null;
    
      if (activePadEl) activePadEl.classList.remove("active");
      if (queuedPadEl) queuedPadEl.classList.remove("queued");
    
      activePadEl = null;
      queuedPadEl = null;
    
      isMonitoring = false;
      updateTrackSubtitle(null);
    }
  
// 🔥 ignoruj keď píšeš do table
if (
  e.target.tagName === "INPUT" ||
  e.target.isContentEditable
) return;

// =======================
// MENU MODE
// =======================
if (viewMode === "menu") {

  if (e.key === "ArrowRight") {
    selectedPadIndex++;
    if (selectedPadIndex >= padsList.length) selectedPadIndex = 0;
    updatePadSelection();
  }

  if (e.key === "ArrowLeft") {
    selectedPadIndex--;
    if (selectedPadIndex < 0) selectedPadIndex = padsList.length - 1;
    updatePadSelection();
  }

  if (e.key === "ArrowUp") {
    const cols = getGridColumns();
selectedPadIndex -= cols;
    if (selectedPadIndex < 0) selectedPadIndex = 0;
    updatePadSelection();
  }

  if (e.key === "ArrowDown") {
    const cols = getGridColumns();
selectedPadIndex += cols;
    if (selectedPadIndex >= padsList.length)
      selectedPadIndex = padsList.length - 1;
    updatePadSelection();
  }

  // 🔥 ENTER = otvor song
  if (e.key === "Enter") {
    const pad = padsList[selectedPadIndex];
    if (pad) pad.click();
  }
}
// =======================
// SONG MODE (PAD NAV)
// =======================
if (viewMode === "song") {

  if (e.key === "ArrowRight") {
    selectedPadIndex++;
    if (selectedPadIndex >= padsList.length) selectedPadIndex = 0;
    updatePadSelection();
  }

  if (e.key === "ArrowLeft") {
    selectedPadIndex--;
    if (selectedPadIndex < 0) selectedPadIndex = padsList.length - 1;
    updatePadSelection();
  }

  if (e.key === "ArrowUp") {
    const cols = getGridColumns();
    selectedPadIndex -= cols;
    if (selectedPadIndex < 0) selectedPadIndex = 0;
    updatePadSelection();
  }

  if (e.key === "ArrowDown") {
    const cols = getGridColumns();
    selectedPadIndex += cols;
    if (selectedPadIndex >= padsList.length)
      selectedPadIndex = padsList.length - 1;
    updatePadSelection();
  }

  // ENTER = play
  if (e.key === "Enter") {
    const pad = padsList[selectedPadIndex];
    if (pad) pad.click();
  }
}
if (e.key.toLowerCase() === "e") {

  // MENU → nový edit režim song padov
  if (viewMode === "menu") {
    songEditMode = !songEditMode;
    renderSong();
    return;
  }

  // SONG → zatiaľ stále track table
  if (viewMode === "song") {
    trackEditMode = !trackEditMode;
    renderSong();
    return;
  }
}
     // 🔥 FULLSCREEN
  if (e.key.toLowerCase() === "f") {
    toggleFullscreen();
  }

  if (e.key.toLowerCase() === "a") {
    toggleSequence();
  }
  if (e.key.toLowerCase() === "c") {
    metronomeMuted = !metronomeMuted;
    localStorage.setItem("metroMuted", metronomeMuted ? "1" : "0");
  
    if (updateMetroPadFn) updateMetroPadFn();
  }
  
  });

  window.shiftClick = (ms) => {
  clickOffset = ms / 1000;
};

let deferredPrompt = null;

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault(); // ❗ vypne default browser prompt
  deferredPrompt = e;


});



if (
  "serviceWorker" in navigator &&
  location.hostname !== "localhost"
) {
  navigator.serviceWorker.register(
    new URL("../sw.js", import.meta.url)
  )
    .then(() => console.log("✅ SW ready"))
    .catch(err => console.error("SW fail", err));
}

window.testR2Download = async (fileName) => {
  if (!currentUser) {
    console.log("No user");
    return;
  }

  const token = await currentUser.getIdToken();

  const res = await fetch(
    `https://samplton-api.matorybos.workers.dev/audio/${encodeURIComponent(fileName)}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  if (!res.ok) {
    console.error(
      "R2 download failed:",
      res.status,
      await res.text()
    );
    return;
  }

  const buffer = await res.arrayBuffer();


  return buffer;
};

